{
  "en": {
    "account": {
      "password": {
        "edit": {
          "current_password": "Current Password",
          "current_password_note": "We need your current password to confirm your changes.",
          "minimum_length": "(%{count} characters minimum)",
          "new_password": "New Password",
          "new_password_note": "Leave blank if you don't want to change it.",
          "password_confirmation": "New Password (Confirmation)",
          "submit": "Update",
          "title": "Change Password"
        },
        "update": {
          "success": "Password has been successfully updated."
        }
      },
      "profile": {
        "edit": {
          "first_name": "First Name (in Chinese, if any)",
          "first_name_reading": "First Name (in English)",
          "last_name": "Last Name  (in Chinese, if any)",
          "last_name_reading": "Last Name (in English)",
          "phone_number_note_1": "Please enter numbers only without hyphens (-).",
          "phone_number_note_2": "Example: 123-456-7890 → 1234567890",
          "postal_code_note_1": "Please enter numbers only without hyphens (-).",
          "postal_code_note_2": "Example: 123-4567 → 1234567",
          "submit": "Update",
          "title": "Edit Profile"
        },
        "show": {
          "address": "Address",
          "basic_information": "Basic Information",
          "change_password": "Change Password",
          "contact_information": "Contact Information",
          "edit": "Edit",
          "full_name": "Full Name (in Chinese, if any)",
          "full_name_japanese": "Full Name (in English)",
          "logout": "Log Out",
          "occupation": "Occupation",
          "password": "Password",
          "primary_contact_information": "Representative Information",
          "title": "Account Settings"
        },
        "update": {
          "success": "Profile has been successfully updated."
        }
      }
    },
    "account_confirmation": {
      "email": "Email Address",
      "submit": "Resend Confirmation Email",
      "title": "Resend Confirmation Email"
    },
    "account_confirmation_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, click here ▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "We have created your account using the registered email address.",
        "text_10": "※This URL is valid for 24 hours.",
        "text_11": "If the expiration period has passed, please resend the identity verification email from %{confirmation_resend_link}.",
        "text_12": "here",
        "text_2": "To proceed with confirming your reservation or completing necessary procedures, please access the URL below and complete the account verification. ",
        "text_3": "Once the verification is complete, you will be able to log in to your MyPage.",
        "text_4": "Account Verification URL",
        "text_5": "Next Steps",
        "text_6": "1. Access the URL above and complete the account verification.",
        "text_7": "2. Log in to your My Page to check your reservation details.",
        "text_8": "3. Once your reservation request is approved, you can review the necessary procedures via the ToDo List on your MyPage.",
        "text_9": "If you have any questions, please contact the Japan Preschool Exchange Operation Desk."
      },
      "letter_block_3": {
        "text_1": "Japan Preschool Exchange Operation Desk",
        "text_2": "Website: https://preschool-exchange.com/",
        "text_3": "E-mail: support@hoikuen-ryugaku.zendesk.com",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "4-13-9 ROUTE 89 BLDG. 4F Higashi Ueno, Taito-ku, Tokyo",
        "text_7": "https://kitchhike.com"
      }
    },
    "account_confirmation_instructions_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, contact below:",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "Please access the URL below to complete the account verification.",
        "text_2": "Once the verification is complete, you will be able to log in to your MyPage.",
        "text_3": "Account Verification URL",
        "text_4": "If you have any questions, please feel free to contact the Japan Preschool Exchange Operation Desk."
      },
      "letter_block_3": {
        "text_1": "Japan Preschool Exchange Operation Desk",
        "text_2": "Website: https://preschool-exchange.com/",
        "text_3": "E-mail: support@hoikuen-ryugaku.zendesk.com",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "4-13-9 ROUTE 89 BLDG. 4F Higashi Ueno, Taito-ku, Tokyo",
        "text_7": "https://kitchhike.com"
      }
    },
    "account_confirmation_mailer": {
      "confirmation_instructions": {
        "from": "Japan Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Complete Your Account Verification [Japan Preschool Exchange]"
      },
      "custom_welcome_instructions": {
        "from": "Japan Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Complete Your Account Registration by Verifying Your Account [Japan Preschool Exchange]"
      }
    },
    "account_reset_password_email": {
      "letter_block_1": {
        "text_1": "This email address is for distribution purposes only.",
        "text_2": "For inquiries, click here ▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "We have received your request to reset your password.",
        "text_2": "Please set a new password using the link below.",
        "text_3": "Set a New Password"
      },
      "letter_block_3": {
        "text_1": "Japan Preschool Exchange Operation Desk",
        "text_2": "Website: https://preschool-exchange.com/",
        "text_3": "E-mail: support@hoikuen-ryugaku.zendesk.com",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "4-13-9 ROUTE 89 BLDG. 4F Higashi Ueno, Taito-ku, Tokyo",
        "text_7": "https://kitchhike.com"
      }
    },
    "active_entity": {
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}"
        }
      }
    },
    "activemodel": {
      "attributes": {
        "kintone/family_master": {
          "allergenic_foods": "Please select the foods that cause the allergies.",
          "allergy_causes": "Please specify the allergens.",
          "allergy_elimination": "Do you wish to have allergen-free meals provided?",
          "appetite_food": "Appetite",
          "baby_food": "Weaning",
          "birth_date": "Date of birth",
          "breastfeeding": "Feeding",
          "business": "Business",
          "company_name": "Company Name",
          "country": "Country",
          "developmentaldisorder": "Has your child ever been diagnosed with a developmental disability?",
          "diagnosis": "Please specify the diagnostic name.",
          "email_address": "E-mail address",
          "exercise": "Achieved Body Movements",
          "family_relationship": "Relationship to the child participating the program",
          "family_relationship_other": "If the relationship is 'other', please indicate the relationship.",
          "favorite_playing": "Favorite Activities",
          "first_name": "First Name (in Chinese Characters, if any)",
          "first_name_reading": "First Name (in English)",
          "food_allergies_yes_or_no": "Does this child have any food allergies?",
          "foodrequest": "Fill in any special requests for meals.",
          "foodrequest_yes_or_no": "Is there any special consideration needed regarding meals due to religious reasons or a plant-based diet (such as vegetarianism)?",
          "full_name": "Full Name (in Chinese Characters, if any)",
          "full_name_reading": "Full Name (in English)",
          "gender": "Gender",
          "language": "Language(s) spoken by this child",
          "last_name": "Last Name (in Chinese Characters, if any)",
          "last_name_reading": "Last Name (in English)",
          "medical_history": "Does this child have any history of illness, surgery, injury, or treatment?",
          "medical_history_details": "Please specify the details of medical history.",
          "municipalities": "City/Town/Village",
          "name_of_building": "Building name, etc.",
          "napping": "Nap",
          "nonfood_allergies": "Does this child have any non-food allergies?",
          "opportunitynurseryschool": "Has this child attended any childcare/educational facilities for more than 3 days a week?",
          "other_food_name": "If other, please specify the ingredients.",
          "personality": "Please tell us about the positive characteristics you see in your child and the areas you would like to improve.",
          "phone_number": "Phone number",
          "planned_participation": "Program Type",
          "postal_code": "Postal code",
          "prefecture": "State/Province",
          "question1": "Please consult with the childcare/educational facility directly at the time of the online pre-meeting and follow the necessary procedures if your child has any special dietary needs. Please note that the availability and level of accommodation for allergen-free meals may vary by facility.",
          "same_as_representative_address": "Same as the representative",
          "same_as_representative_phone_number": "Same as the representative",
          "school_name": "Please name of the school your child currently attends.",
          "school_type": "Please select the type of school your child currently attends.",
          "symptoms": "Please describe the allergy symptoms in detail.",
          "things_that_need_attention": "Please provide details if there are any developmental delays or considerations needed for your child in a group setting.",
          "toilet": "Toilet Habits",
          "town_area_street_address": "Street number/Other address",
          "underwear": "Underwear"
        },
        "kintone/representative_user_master": {
          "birth_date": "Date of Birth",
          "building": "Building (Optional)",
          "business": "Occupation",
          "co_workers": "Co_Worker",
          "company_name": "Company Name",
          "country": "Country",
          "email_address": "Email Address",
          "family_relationship": "Relation to Participating Child",
          "first_name": "First Name",
          "first_name_reading": "First Name (Reading)",
          "gender": "Gender",
          "last_name": "Last Name",
          "last_name_reading": "Last Name (Reading)",
          "municipalities": "City/Town/Village",
          "name_of_building": "Building Name, etc.",
          "number_of_appointments": "Number of Appointments",
          "number_of_cancellations": "Number of Cancellations",
          "number_of_reservations": "Number of Reservations",
          "other": "Other",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "prefecture": "State/Province",
          "prefecture_text": "Prefecture",
          "town": "Town",
          "town_area_street_address": "Street Number/Other Address"
        },
        "kintone/reservation_request": {
          "billing_fee": "Billing Total",
          "billing_fee_total": "Billing Total",
          "cancel_fee": "Cancellation Fee",
          "cancel_processed_date": "Cancellation Date",
          "charge_date": "Payment Date",
          "check_in_time": "Arrival Time at the Accommodation",
          "discount_amount": "Discounted Price",
          "emergency_contact1": "Emergency Contact #1",
          "emergency_contact2": "Emergency Contact #2",
          "end_of_stay": "Check-out Date",
          "guardian_name": "Name of Parent/Guardian Who will be Picking up and Dropping off Your Child(ren)",
          "id": "Reservation Number",
          "interview": "Would you be willing to cooperate with interviews and media coverage during and after your stay?",
          "number_of_adults": "Number of Adults",
          "number_of_preschoolers": "Preschool Participants",
          "number_of_preschoolers_1": "Not in the Program (Aged 0 to 6 Years)",
          "number_of_students": "Not in the Program (Aged 7 to 12 Years)",
          "number_of_students_1": "Elementary School Participants",
          "nursery_name": "Childcare/Educational Facility",
          "nursery_name_0": "Childcare/Educational Facility_2",
          "option_count": "Options Count",
          "option_name": "Options",
          "option_price": "Options Price",
          "option_total": "Options Total",
          "plan_name": "Plan Name",
          "prtrait_right": "Do you agree that your child's photo may be used in local publicity, on the official website of Japan Preschool Exchange, and in media such as magazines and television?",
          "room_name": "Accommodation",
          "route": "Please tell us the motivation/reason for your participation.",
          "route_others": "Other",
          "start_of_stay": "Check-in Date",
          "total_number_of_people": "Total Guests"
        }
      },
      "errors": {
        "messages": {
          "blank": "Please enter",
          "inclusion": "Please select",
          "too_long": "Please enter no more than %{count} characters"
        }
      },
      "models": {
        "kintone": {
          "family_master": "family_master",
          "representative_user_master": "representative_user_master"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "user": {
          "confirmation_sent_at": "Confirmation sent at",
          "confirmation_token": "Confirmation token",
          "confirmed_at": "Confirmed at",
          "created_at": "Created at",
          "current_password": "Current password",
          "current_sign_in_at": "Current sign in at",
          "current_sign_in_ip": "Current sign in IP",
          "email": "Email",
          "encrypted_password": "Encrypted password",
          "failed_attempts": "Failed attempts",
          "last_sign_in_at": "Last sign in at",
          "last_sign_in_ip": "Last sign in IP",
          "locked_at": "Locked at",
          "password": "Password",
          "password_confirmation": "Password confirmation",
          "remember_created_at": "Remember created at",
          "remember_me": "Remember me",
          "representative_building": "Building (Optional)",
          "representative_business": "Occupation",
          "representative_co_workers": "Co-workers",
          "representative_company_name": "Company Name (Optional)",
          "representative_country": "Country",
          "representative_day": "Day",
          "representative_family_relationship": "Family Relationship",
          "representative_first_name": "First Name",
          "representative_first_name_reading": "First Name (Reading)",
          "representative_gender": "Gender",
          "representative_last_name": "Last Name",
          "representative_last_name_reading": "Last Name (Reading)",
          "representative_month": "Month",
          "representative_municipalities": "Municipalities",
          "representative_other": "Other (Optional)",
          "representative_phone_number": "Phone Number",
          "representative_postal_code": "Postal Code",
          "representative_prefecture": "Prefecture",
          "representative_town": "Town",
          "representative_year": "Year",
          "reset_password_sent_at": "Reset password sent at",
          "reset_password_token": "Reset password token",
          "sign_in_count": "Sign in count",
          "unconfirmed_email": "Unconfirmed email",
          "unlock_token": "Unlock token",
          "updated_at": "Updated at"
        }
      },
      "errors": {
        "messages": {
          "record_invalid": "Validation failed: %{errors}",
          "restrict_dependent_destroy": {
            "has_many": "Cannot delete record because dependent %{record} exist",
            "has_one": "Cannot delete record because a dependent %{record} exists"
          }
        },
        "models": {
          "review": {
            "attributes": {
              "publication_status": {
                "inclusion": "must be true or false."
              }
            }
          },
          "user": {
            "attributes": {
              "password": {
                "complexity": "must be between 8 and 64 characters and include at least one lowercase letter and one digit."
              }
            }
          }
        }
      },
      "models": {
        "user": {
          "one": "User",
          "other": "Users"
        }
      }
    },
    "common": {
      "foot_consultation": {
        "button": "Consult with us about Japan Preschool Exchange",
        "lead_1": "Consult with our Japan Preschool Exchange planner",
        "lead_2": "",
        "notes": "Our Japan Preschool Exchange planner will support you in selecting a destination that fits your preferences, as well as consulting with you on any concerns you may have about our program. Please feel free to consult with us via chat or online meeting (Zoom).",
        "url": "https://preschool-exchange.com/#apply"
      },
      "footer": {
        "consult": {
          "link": "Contact our planner for consultation",
          "notes": "For those who require special support such as allergies, our planner will be happy to assist.",
          "title": "For Families with Special Needs",
          "url": "https://preschool-exchange.com/#planner"
        },
        "fee": {
          "link": "What is included in the fee?",
          "notes": "Please see below for information about the price details.",
          "title": "About the Price",
          "url": "https://preschool-exchange.com/#plan"
        },
        "landing_page": {
          "about": "",
          "company_info": "",
          "conditions": "Conditions of Transaction",
          "contact_about_banner": "",
          "contact_modal": {
            "after_booking": "",
            "before_booking": "",
            "go_to_line": "",
            "go_to_mail": "",
            "title": ""
          },
          "contact_via_line": "",
          "elementary_school": "",
          "faq": "",
          "inquiries": "Inquiries",
          "invite_friend": "",
          "kitchhike_company": "",
          "mypage_button": "Participant Families Only - MyPage",
          "operation_company": "",
          "plan_contact": "",
          "plan_hint": "",
          "plan_list": "",
          "price_plan": "",
          "privacy_policy": "Privacy Policy",
          "recruit": "",
          "related_service": "",
          "responsibility": "",
          "search_plan": "",
          "stipulation": "Stipulation for Travel Agency",
          "study_abroad_experience": "",
          "study_abroad_tax": "",
          "terms_of_use": "Terms of Service",
          "title": "",
          "travel_deal_details": "Travel Transaction Details",
          "your_nursery": ""
        },
        "request": {
          "link_1": "Request to All Families",
          "link_2": "Cancellation Policy",
          "notes": "The Japan Preschool Exchange program is a collaborative initiative involving childcare/educational facilities, accommodations, and local communities. Please review the following list of requests that we kindly ask you to adhere to when participating.",
          "title": "Read Before Reserving",
          "url_1": "https://japan.preschool-exchange.com/request/en"
        },
        "sitemap": {
          "link_text_1": "Management Company",
          "link_text_2": "Contact Us",
          "link_text_3": "Details of Travel Transactions",
          "link_text_4": "Travel Agency Terms and Conditions",
          "link_text_5": "Conditions of Transaction",
          "url_1": "https://kitchhike.jp/",
          "url_2": "mailto:support@hoikuen-ryugaku.zendesk.com",
          "url_3": "https://hoikuen-ryugaku.com/travel-deal-details",
          "url_4": "https://japan.preschool-exchange.com/stipulation/en",
          "url_5": "https://japan.preschool-exchange.com/conditions/en"
        }
      },
      "google_tag_manager": {
        "id": "GTM-KN865G3B"
      },
      "header": {
        "back_path_text": "Service Site",
        "logo": "/images/logo_image_en.jpg",
        "menu": {
          "mypage": "MyPage",
          "mypage_top": "MyPage",
          "service_top": "Service Site"
        },
        "title": "Reservation Site",
        "url": "https://preschool-exchange.com/"
      },
      "message_bar": {
        "holiday": "--- Notice of year-end and New Year holidays ---\nHoliday period: December 28, 2024 (Sat.) - January 5, 2025 (Sun.)\nReservation request results will be confirmed and communicated sequentially from January 6, after the New Year.\nWe apologize for any inconvenience this may cause and appreciate your understanding and cooperation.\n",
        "maintenance": "Due to ongoing system maintenance, operations may be unstable. If you encounter any issues, please wait a moment and try again later."
      }
    },
    "date": {
      "abbr_day_names": [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
      ],
      "abbr_month_names": [
        null,
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      "day_names": [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
      ],
      "formats": {
        "date_full_with_weekday": "%Y-%m-%d, %a",
        "default": "%Y-%m-%d",
        "long": "%B %d, %Y",
        "short": "%b %d",
        "year_and_month_and_day": "%-b %-d, %Y"
      },
      "month_names": [
        null,
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "datetime": {
      "distance_in_words": {
        "about_x_hours": {
          "one": "about 1 hour",
          "other": "about %{count} hours"
        },
        "about_x_months": {
          "one": "about 1 month",
          "other": "about %{count} months"
        },
        "about_x_years": {
          "one": "about 1 year",
          "other": "about %{count} years"
        },
        "almost_x_years": {
          "one": "almost 1 year",
          "other": "almost %{count} years"
        },
        "half_a_minute": "half a minute",
        "less_than_x_minutes": {
          "one": "less than a minute",
          "other": "less than %{count} minutes"
        },
        "less_than_x_seconds": {
          "one": "less than 1 second",
          "other": "less than %{count} seconds"
        },
        "over_x_years": {
          "one": "over 1 year",
          "other": "over %{count} years"
        },
        "x_days": {
          "one": "1 day",
          "other": "%{count} days"
        },
        "x_minutes": {
          "one": "1 minute",
          "other": "%{count} minutes"
        },
        "x_months": {
          "one": "1 month",
          "other": "%{count} months"
        },
        "x_seconds": {
          "one": "1 second",
          "other": "%{count} seconds"
        }
      },
      "prompts": {
        "day": "Day",
        "hour": "Hour",
        "minute": "Minute",
        "month": "Month",
        "second": "Seconds",
        "year": "Year"
      }
    },
    "day": {
      "formats": {
        "short": {
          "friday": "Fri",
          "monday": "Mon",
          "saturday": "Sat",
          "sunday": "Sun",
          "thursday": "Thu",
          "tuesday": "Tue",
          "wednesday": "Wed"
        }
      }
    },
    "devise": {
      "confirmations": {
        "account_verified": "Account verified.",
        "already_confirmed": "This email address has already been confirmed.",
        "confirmation_sent": "A confirmation email has been sent.",
        "confirmed": "Your email address has been successfully confirmed.",
        "failed": "Failed to confirm your email address. The confirmation link may be invalid or the email address may have already been confirmed.",
        "new": {
          "resend_confirmation_instructions": "Resend confirmation instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to confirm your email address in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive an email with instructions for how to confirm your email address in a few minutes."
      },
      "failure": {
        "already_authenticated": "You are already signed in.",
        "inactive": "Your account is not activated yet.",
        "invalid": "Invalid %{authentication_keys} or password.",
        "last_attempt": "You have one more attempt before your account is locked.",
        "locked": "Your account is locked.",
        "not_found_in_database": "Invalid %{authentication_keys} or password.",
        "timeout": "Your session expired. Please sign in again to continue.",
        "unauthenticated": "You need to sign in or sign up before continuing.",
        "unconfirmed": "You have to confirm your email address before continuing."
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "Confirm my account",
          "greeting": "Welcome %{recipient}!",
          "instruction": "You can confirm your account email through the link below:",
          "subject": "Confirmation instructions"
        },
        "email_changed": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your email has been changed to %{email}.",
          "message_unconfirmed": "We're contacting you to notify you that your email is being changed to %{email}.",
          "subject": "Email Changed"
        },
        "password_change": {
          "greeting": "Hello %{recipient}!",
          "message": "We're contacting you to notify you that your password has been changed.",
          "subject": "Password Changed"
        },
        "reset_password_instructions": {
          "action": "Change my password",
          "greeting": "Hello %{recipient}!",
          "instruction": "Someone has requested a link to change your password. You can do this through the link below.",
          "instruction_2": "If you didn't request this, please ignore this email.",
          "instruction_3": "Your password won't change until you access the link above and create a new one.",
          "subject": "Reset password instructions"
        },
        "unlock_instructions": {
          "action": "Unlock my account",
          "greeting": "Hello %{recipient}!",
          "instruction": "Click the link below to unlock your account:",
          "message": "Your account has been locked due to an excessive number of unsuccessful sign in attempts.",
          "subject": "Unlock instructions"
        }
      },
      "omniauth_callbacks": {
        "failure": "Could not authenticate you from %{kind} because \"%{reason}\".",
        "success": "Successfully authenticated from %{kind} account."
      },
      "passwords": {
        "edit": {
          "change_my_password": "Change my password",
          "change_your_password": "Change your password",
          "confirm_new_password": "Confirm new password",
          "new_password": "New password"
        },
        "new": {
          "forgot_your_password": "Forgot your password?",
          "send_me_reset_password_instructions": "Send me reset password instructions"
        },
        "no_token": "You can't access this page without coming from a password reset email. If you do come from a password reset email, please make sure you used the full URL provided.",
        "send_instructions": "You will receive an email with instructions on how to reset your password in a few minutes.",
        "send_paranoid_instructions": "If your email address exists in our database, you will receive a password recovery link at your email address in a few minutes.",
        "updated": "Your password has been changed successfully. You are now signed in.",
        "updated_not_active": "Your password has been changed successfully."
      },
      "registrations": {
        "destroyed": "Bye! Your account has been successfully cancelled. We hope to see you again soon.",
        "edit": {
          "are_you_sure": "Are you sure?",
          "cancel_my_account": "Cancel my account",
          "currently_waiting_confirmation_for_email": "Currently waiting confirmation for: %{email}",
          "leave_blank_if_you_don_t_want_to_change_it": "leave blank if you don't want to change it",
          "title": "Edit %{resource}",
          "unhappy": "Unhappy?",
          "update": "Update",
          "we_need_your_current_password_to_confirm_your_changes": "we need your current password to confirm your changes"
        },
        "invalid_credentials": "Invalid email or password.",
        "new": {
          "sign_up": "Sign up"
        },
        "signed_up": "Welcome! You have signed up successfully.",
        "signed_up_but_inactive": "You have signed up successfully. However, we could not sign you in because your account is not yet activated.",
        "signed_up_but_locked": "You have signed up successfully. However, we could not sign you in because your account is locked.",
        "signed_up_but_unconfirmed": "A message with a confirmation link has been sent to your email address. Please follow the link to activate your account.",
        "update_needs_confirmation": "Profile has been successfully updated, but we need to verify your new email address. Please check your email and follow the confirmation link to confirm your new email address.",
        "updated": "Your account has been updated successfully.",
        "updated_but_not_signed_in": "Your account has been updated successfully, but since your password was changed, you need to sign in again."
      },
      "sessions": {
        "already_signed_out": "Signed out successfully.",
        "new": {
          "sign_in": "Log in"
        },
        "signed_in": "Signed in successfully.",
        "signed_out": "Signed out successfully."
      },
      "shared": {
        "links": {
          "back": "Back",
          "didn_t_receive_confirmation_instructions": "Didn't receive confirmation instructions?",
          "didn_t_receive_unlock_instructions": "Didn't receive unlock instructions?",
          "forgot_your_password": "Forgot your password?",
          "sign_in": "Log in",
          "sign_in_with_provider": "Sign in with %{provider}",
          "sign_up": "Sign up"
        },
        "minimum_password_length": {
          "one": "(%{count} character minimum)",
          "other": "(%{count} characters minimum)"
        }
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "Resend unlock instructions"
        },
        "send_instructions": "You will receive an email with instructions for how to unlock your account in a few minutes.",
        "send_paranoid_instructions": "If your account exists, you will receive an email with instructions for how to unlock it in a few minutes.",
        "unlocked": "Your account has been unlocked successfully. Please sign in to continue."
      }
    },
    "discount_code_mailer": {
      "discount_code_email": {
        "subject": "The referral code has been successfully issued [Japan Preschool Exchange]"
      }
    },
    "enumerize": {
      "kintone/family_master": {
        "allergenic_foods": {
          "egg": "Egg",
          "fruit": "Fruits",
          "meat_fish": "Meat/Fish",
          "milk": "Milk/Milk and dairy products",
          "others": "Others",
          "shellfish": "Crustaceans",
          "soy": "Beans, Grains, Seeds",
          "wheat": "Wheat"
        },
        "allergy_elimination": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "appetite_food": {
          "high": "Hearty appetite",
          "low": "Limited appetite",
          "normal": "Average appetite"
        },
        "baby_food": {
          "before_start": "Before starting solid food introduction.",
          "complete": "Transitioned to a fully solid food diet.",
          "early": "Introducing simple, pureed or mashed foods.",
          "late": "Introducing soft, small pieces of food and encouraging self-feeding.",
          "middle": "Introducing a variety of textured foods.",
          "toddler": "Toddler meals"
        },
        "breastfeeding": {
          "breast_milk": "Exclusively breastfeeding",
          "formula": "Formula milk",
          "mixed": "Mixed feeding",
          "weaned": "Weaned"
        },
        "business": {
          "company_employee_1": "Company employee",
          "company_employee_2": "Company employee (support staff)",
          "contract_employee": "Contract employee / Temporary employee",
          "housewife": "Housewife/Househusband",
          "manager": "Manager / Executive",
          "medical_personnel": "Medical personnel",
          "other": "Other",
          "part_timer": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employed": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "unemployed": "Unemployed"
        },
        "developmentaldisorder": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "exercise": {
          "crawling": "Crawling",
          "rolling_over": "Rolling Over",
          "standing_with_support": "Standing with Support",
          "walking": "Walking"
        },
        "family_relationship": {
          "brother": "Brother/Sister",
          "father": "Father",
          "grandfather": "Grandfather",
          "grandmother": "Grandmother",
          "member": "member",
          "mother": "Mother",
          "other": "Other"
        },
        "food_allergies_yes_or_no": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "foodrequest_yes_or_no": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other"
        },
        "medical_history": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "napping": {
          "alone": "Nap alone",
          "carried": "Needs to be carried on someone's back",
          "cuddle": "Needs a companion for napping",
          "held": "Nap while being held or carried"
        },
        "nonfood_allergies": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "opportunitynurseryschool": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "planned_participation": {
          "daycare": "Japan Preschool Exchange",
          "elementary": "Japan Elementary Exchange and Camp Programs"
        },
        "question1": {
          "answer": "Confirmed"
        },
        "same_as_representative_address": {
          "same_as_representative_address": "same_as_representative_address"
        },
        "same_as_representative_phone_number": {
          "same_as_representative_phone_number": "same_as_representative_phone_number"
        },
        "school_type": {
          "national": "National",
          "private": "Private",
          "public": "Public"
        },
        "toilet": {
          "fail": "Cannot use toilet",
          "success": "Can use toilet",
          "training": "Practicing"
        },
        "underwear": {
          "cloth_diaper": "Cloth diapers",
          "cloth_pants": "Cloth Pants",
          "disposable_diaper": "Paper diapers",
          "training_pants": "Training Pants"
        }
      },
      "kintone/representative_user_master": {
        "business": {
          "company_employee_1": "Company employee",
          "company_employee_2": "Company employee (support staff)",
          "contract_employee": "Contract employee / Temporary employee",
          "housewife": "Housewife/Househusband",
          "manager": "Manager / Executive",
          "medical_personnel": "Medical personnel",
          "other": "Other",
          "part_timer": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employed": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "unemployed": "Unemployed"
        },
        "co_workers": {
          "no_answer": "No",
          "yes_answer": "Yes"
        },
        "family_relationship": {
          "brother": "Brother/Sister",
          "father": "Father",
          "grandfather": "Grandfather",
          "grandmother": "Grandmother",
          "member": "member",
          "mother": "Mother",
          "other": "Other"
        },
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other"
        }
      },
      "kintone/reservation_request": {
        "interview": {
          "cooperation": "Cooperation.",
          "no_cooperation": "I will not cooperate."
        },
        "prtrait_right": {
          "limited_permission": "I give permission for my photos to be shared exclusively for personal use by persons/guardians associated with the childcare/educational facility (e.g., in communication notebooks, etc.).",
          "no_permission": "I do not permit the publication of photographs.",
          "yes_permission": "I give permission for my photo to be published."
        },
        "route": {
          "facebook": "Facebook",
          "family": "Referral from parents or family members",
          "flyers": "Flyers",
          "friends": "Referral from a friend or colleague",
          "instagram": "Instagram",
          "line": "LINE",
          "newspapers": "Newspapers",
          "other": "Other",
          "preschool": "Referral from the preschool my child attends",
          "search": "Web Search",
          "tv": "TV",
          "web_news": "Web news/web articles",
          "x": "X",
          "youtube": "Youtube"
        }
      }
    },
    "error_page": {
      "back_path": "Back to Bookable Destinations"
    },
    "errors": {
      "connection_refused": "Oops! Failed to connect to the Web Console middleware.\nPlease make sure a rails development server is running.\n",
      "format": "%{attribute} %{message}",
      "messages": {
        "accepted": "must be accepted",
        "already_confirmed": "was already confirmed, please try signing in",
        "blank": "can't be blank",
        "confirmation": "doesn't match Password.",
        "confirmation_period_expired": "needs to be confirmed within %{period}, please request a new one",
        "duplicated": "duplicated",
        "empty": "can't be empty",
        "equal_to": "must be equal to %{count}",
        "even": "must be even",
        "exclusion": "is reserved",
        "expired": "has expired, please request a new one",
        "greater_than": "must be greater than %{count}",
        "greater_than_or_equal_to": "must be greater than or equal to %{count}",
        "in": "must be in %{count}",
        "inclusion": "is not included in the list",
        "invalid": "is invalid.",
        "less_than": "must be less than %{count}",
        "less_than_or_equal_to": "must be less than or equal to %{count}",
        "model_invalid": "Validation failed: %{errors}",
        "non_subset": "is not subset of the given list",
        "not_a_number": "is not a number",
        "not_an_integer": "must be an integer",
        "not_found": "not found",
        "not_locked": "was not locked",
        "not_saved": {
          "one": "1 error prohibited this %{resource} from being saved:",
          "other": "%{count} errors prohibited this %{resource} from being saved:"
        },
        "odd": "must be odd",
        "only_numbers_allowed": "Please enter numbers only.",
        "other_than": "must be other than %{count}",
        "password_invalid": "Password is invalid.",
        "present": "must be blank",
        "required": "must exist",
        "taken": "has already been taken",
        "too_long": {
          "one": "is too long (maximum is 1 character)",
          "other": "is too long (maximum is %{count} characters)"
        },
        "too_short": "is too short (minimum is %{count} characters).",
        "wrong_length": {
          "one": "is the wrong length (should be 1 character)",
          "other": "is the wrong length (should be %{count} characters)"
        }
      },
      "unacceptable_request": "A supported version is expected in the Accept header.\n",
      "unavailable_session": "Session %{id} is no longer available in memory.\n\nIf you happen to run on a multi-process server (like Unicorn or Puma) the process\nthis request hit doesn't store %{id} in memory. Consider turning the number of\nprocesses/workers to one (1) or using a different server in development.\n"
    },
    "flash": {
      "actions": {
        "create": {
          "notice": "%{resource_name} was successfully created."
        },
        "destroy": {
          "alert": "%{resource_name} could not be destroyed.",
          "notice": "%{resource_name} was successfully destroyed."
        },
        "update": {
          "notice": "%{resource_name} was successfully updated."
        }
      }
    },
    "hello": "Hello world",
    "helpers": {
      "select": {
        "prompt": "Please select"
      },
      "submit": {
        "complete": "Proceed to Complete",
        "create": "Create %{model}",
        "save": "save",
        "submit": "submit",
        "update": "Update %{model}"
      }
    },
    "login": {
      "email": "Email Address",
      "password": "Password",
      "reset_password": "Forgot your password? Click here",
      "submit": "Log In",
      "title": "Login"
    },
    "mailer": {
      "from": "Japan Preschool Exchange Operation Desk <no-reply@kitchhike.com>"
    },
    "message": {
      "error": {
        "address": {
          "load": "Failed to search address. Please enter address manually."
        },
        "card": {
          "expiration_date": {
            "expired": "Your card has expired.",
            "incorrect": "The expiration date of your card is incorrect."
          },
          "number": {
            "incorrect": "The number of your card is incorrect."
          },
          "security_code": {
            "incorrect": "The security code of your card is incorrect."
          }
        },
        "code": {
          "e_000": "An unexpected error has occurred. Please contact the Operation Desk for assistance.",
          "e_001": "The start date is invalid, or the check-in date has already been booked. Please double-check if the dates are available for reservation.",
          "e_002": "The input parameters are incorrect. Please review the selected destination, plan, and dates.",
          "e_003": "The email address you entered already has a reservation for this period. Please review the reservation details sent in the email.",
          "e_004": "The destination could not be found. Please review the selected destination.",
          "e_005": "The plan could not be found. Please review the selected plan.",
          "e_006": "The accommodation could not be found. Please review the selected plan and dates.",
          "e_007": "The accommodation could not be found. Please review the selected plan and dates.",
          "e_008": "The number of available dates for sale does not match the length of stay. Please contact the Operation Desk for assistance."
        },
        "email": {
          "load": "Failed to check if the email address is available for registration."
        },
        "error_001": "Error: data available_sale_date of next month is empty",
        "error_002": "Error: data available_sale_date is not equal with real stay_day",
        "error_003": "Error: One of the Available Sale Date records has a status other than 販売中.",
        "field": {
          "date": "Date"
        },
        "input": {
          "check": "Please check %{field_name}.",
          "email_exists": "This email address is already registered. Please log in using the link above.",
          "enter": "Please enter %{field_name}.",
          "password_mismatch": "The passwords do not match.",
          "select": "Please select %{field_name}.",
          "valid_enter": "Please enter valid %{field_name}."
        },
        "please_try_again": "Please try again after some time.",
        "promotion": {
          "already_used": "This promotion code has already been used.",
          "invalid_code": "This promotion code is invalid.",
          "invalid_period": "This promotion code is outside of an available period.",
          "invalid_plan": "This promotion code is not applicable to this plan.",
          "own_code": "Your own referral code cannot be used."
        }
      },
      "error_404": "404 Not Found",
      "error_422": "422 Unprocessable Entity",
      "error_500": "500 Internal Server Error"
    },
    "month": {
      "abbr_month_names": {
        "1": "Jan",
        "10": "Oct",
        "11": "Nov",
        "12": "Dec",
        "2": "Feb",
        "3": "Mar",
        "4": "Apr",
        "5": "May",
        "6": "Jun",
        "7": "Jul",
        "8": "Aug",
        "9": "Sep"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u%n",
          "precision": 2,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false,
          "unit": "$"
        }
      },
      "format": {
        "delimiter": ",",
        "precision": 3,
        "round_mode": "default",
        "separator": ".",
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "human": {
        "decimal_units": {
          "format": "%n %u",
          "units": {
            "billion": "Billion",
            "million": "Million",
            "quadrillion": "Quadrillion",
            "thousand": "Thousand",
            "trillion": "Trillion",
            "unit": ""
          }
        },
        "format": {
          "delimiter": "",
          "precision": 3,
          "significant": true,
          "strip_insignificant_zeros": true
        },
        "storage_units": {
          "format": "%n %u",
          "units": {
            "byte": {
              "one": "Byte",
              "other": "Bytes"
            },
            "eb": "EB",
            "gb": "GB",
            "kb": "KB",
            "mb": "MB",
            "pb": "PB",
            "tb": "TB"
          }
        }
      },
      "nth": {
      },
      "percentage": {
        "format": {
          "delimiter": "",
          "format": "%n%"
        }
      },
      "precision": {
        "format": {
          "delimiter": ""
        }
      }
    },
    "nursery_meeting_email": {
      "to_nursery": {
        "subject": "ご家族の面談予約を承りました【保育園留学 運営事務局】"
      },
      "to_user": {
        "meeting_date_time": "Date and Time: %{meeting_date_time}",
        "nursery_name": "Location: %{nursery_name}",
        "subject": "Online Pre-Meeting Confirmed [Japan Preschool Exchange]",
        "text1": "Thank you for your reservation. Your meeting has been successfully scheduled.",
        "text2": "Please note that if the reservation is made within three days of the meeting date, there may be adjustments due to the teacher's childcare schedule. Thank you for your understanding.",
        "text3": "As the scheduled meeting time approaches, please check the meeting item in the ToDo List on your MyPage.",
        "text4": "[Check the ToDo List] ",
        "text5": "Please note that changes or cancellations are generally not accepted.\nHowever, if unforeseen circumstances arise, please contact the Preschool Exchange Operation Desk.",
        "user_full_name": "Attendee: %{last_name} %{first_name}",
        "user_name": "Dear %{user_name}"
      }
    },
    "ogp": {
      "confirmation": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Resend Confirmation Email"
        }
      },
      "error": {
        "show": {
          "title": "Error"
        }
      },
      "landing_page": {
        "title": "JAPAN PRESCHOOL EXCHANGE | %{nursery_name}"
      },
      "mypage": {
        "index": {
          "title": "JAPAN PRESCHOOL EXCHANGE | My Page"
        }
      },
      "plan": {
        "index": {
          "description": "You can check the plan list of %{alias}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Plans List of %{alias}"
        },
        "show": {
          "description": "You can check the details of the plan of %{plan_name}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Plan Detail of %{plan_name}"
        }
      },
      "profile": {
        "show": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Profile"
        }
      },
      "referral_code": {
        "complete": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Referral Code Issuance Completed"
        },
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Referral Code Issuance Information Entry"
        }
      },
      "registration": {
        "edit": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Email Address Change"
        }
      },
      "reservation": {
        "complete": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Reservation Confirmation"
        },
        "confirm": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Reservation Confirmation"
        },
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Reservation Details Input"
        }
      },
      "reset_password": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Reset Password"
        }
      },
      "reviews": {
        "index": {
          "description": "You can check the family voice list of %{alias}.",
          "title": "JAPAN PRESCHOOL EXCHANGE | Family Voice List of %{alias}"
        }
      },
      "session": {
        "new": {
          "title": "JAPAN PRESCHOOL EXCHANGE | Login"
        }
      },
      "site_name": "JAPAN PRESCHOOL EXCHANGE | Reservation Request Site",
      "top": {
        "index": {
          "description": "You can check the availability and fees of Japan Preschool Exchange programs.",
          "image": "/images/nursery_OGP_image_en.jpg",
          "title": "JAPAN PRESCHOOL EXCHANGE | Destinations List"
        }
      }
    },
    "password": {
      "confirm_password": "Confirm Password",
      "email": "Email Address",
      "notes_1": "A password reset URL will be sent to the provided email address.",
      "password": "Password",
      "reset_button": "Set Password",
      "reset_email_submit": "Send",
      "title": "Reset Password"
    },
    "plan_detail": {
      "access": {
        "address": "Address : %{postal_code}",
        "title": "Access"
      },
      "accommodation": {
        "title": "Accommodation",
        "type": "Accommodation Type : %{type}, Max. %{capacity} Guests"
      },
      "back_path": "Back to Destination List",
      "carousel": {
        "more": "See More Photos"
      },
      "check_in_out": {
        "check_in": "Check-in",
        "check_out": "Check-out",
        "title": "Check-in and Check-out"
      },
      "childcare": {
        "notes": "Check what to bring and attire",
        "title": "Program Hours",
        "weekdays": "Weekdays : %{start_time}〜%{end_time} (%{hours} hours)"
      },
      "eligibility": "Eligibility : %{eligibility}",
      "extended": {
        "title": "Extended Program Hours"
      },
      "facility": {
        "notes": "Check Facilities Detail",
        "title": "Facilities and Amenities"
      },
      "label": {
        "aboard_accept_class": "Age range",
        "access": "Access",
        "address": "Address",
        "allergy": "Children with Allergies",
        "childcare_time": "Time",
        "elementary_accept_class": "Grade",
        "entry_requirement": "Children without prior preschool experience",
        "extending_time": "Extended Program Hours",
        "google_map": "Check on Google map",
        "lunch": "Preschool Lunch"
      },
      "local": {
        "button": "View Details of This Destination",
        "text": "For more detailed information on the location, such as the charms and features of the preschools, living environment, workspace, neighborhood map, and weekend activities, please visit our website.",
        "title": "Local Information"
      },
      "navigation": {
        "accommodation": "Accommodation",
        "available_plan": "Available Plans",
        "family_voice": "Family Voices",
        "nursery_info": "Preschool / Educational Facility"
      },
      "preschool": "Preschool / Educational Facility",
      "remote_work": {
        "title": "Working Space"
      },
      "reservation": {
        "breakdown": "Price Details",
        "button": "Reserve",
        "date_range": {
          "select": "Select a Date"
        },
        "modal": {
          "breakdown": {
            "adult_rate": "Adult Rate (1 night)",
            "basic_price": "Basic Price",
            "child_rate": "Child Rate (1 night)",
            "elementary_aboard": "Elementary Exchange and Camp Programs : JPY %{unit_price} ×",
            "not_and_elementary": "Not in Program (Aged 7-12) : JPY %{unit_price} ×",
            "not_and_toddler": "Not in Program (Aged 0-6) : JPY %{unit_price} ×",
            "nursery_aboard": "Preschool Exchange Program : JPY %{unit_price} ×",
            "option_price": "Option Price (tax included)",
            "plan_price": "Plan Price (tax included)",
            "title": "Price Breakdown",
            "total": "Total Fee (tax included)"
          },
          "clear": "Clear",
          "close": "Close",
          "people": {
            "adult": "Adult",
            "child": "Child",
            "elementary_aboard": "Elementary Exchange and Camp Programs",
            "not_and_elementary": "Not in the Program (Aged 7-12)",
            "not_and_toddler": "Not in the Program (Aged 0-6)",
            "notes_1": "Please input your child's age based on the start date of the program. Some plans may have age restrictions.",
            "notes_3": "If there are accompanying family members (adults) for only a few days, please enter the number of people and the length of stay in the Option Selection on the next screen.",
            "nursery_aboard": "Preschool Exchange Program",
            "nursery_elementary_aboard": "保育園留学・小学生留学",
            "title": "Number of Guests"
          },
          "save": "Save"
        },
        "sold_out": "Sold Out",
        "total": "Total Fee"
      },
      "reviews": {
        "read_more": "Read more",
        "read_others": "View all %{count} reviews"
      },
      "room_info": {
        "accommodation_info": "Accommodation Overview",
        "accommodation_type": "Accommodation Type",
        "address": "Address",
        "bathroom": "Bathroom",
        "bedroom": "Bedroom",
        "capacity": {
          "number": {
            "one": "Max. %{count} Person",
            "other": "Max. %{count} People"
          },
          "title": "Capacity"
        },
        "kitchen": "Kitchen",
        "laundry": "Laundry",
        "meal_service": "Food Service",
        "pets": "Pet",
        "separate_room": "Separate Workspace for Couples",
        "transportation": "Transportation",
        "wifi": "Wi-Fi"
      },
      "same_region_plan": "Other Plans",
      "section": {
        "access_way": "Access (accommodation↔︎childcare facility)",
        "accommodation": "Accommodation",
        "accommodation_access_aboard": "Access between Educational facility to Accommodation",
        "accommodation_access_nursery": "Access between Preschool to Accommodation",
        "accommodation_info": "Accommodation Overview",
        "available_plan": "Available Plans",
        "educational_facility": "Educational Facility",
        "family_voice": "Family Voices",
        "preschool_facility": "Preschool Facility"
      },
      "view_detail": "View Details of This Destination",
      "view_detail_accommodation": "View Details of This Accommodation"
    },
    "plan_list": {
      "back_path": "Back to Destinations List",
      "component": {
        "accept_class": "Acceptance Class",
        "button": {
          "available_date": "Available Date",
          "select": "I'll reserve",
          "sold_out": "Sold Out"
        },
        "capacity": {
          "all": "Capacity %{count} people",
          "one": "Max. %{count} Person",
          "other": "Max. %{count} People"
        },
        "currency": "JPY",
        "estimate": "Estimate for 2 adults and 1 child",
        "inquire_whatapp": "Inquire via WhatsApp",
        "loading": "Loading...",
        "lp_check_availability": "Check Availability",
        "lp_see_more": "View Details",
        "see_more": "View more",
        "slot": {
          "full": "Sold Out",
          "left": {
            "one": "%{count} Slot left",
            "other": "%{count} Slots left"
          }
        },
        "time": "Program Hours",
        "year_section": "%{year}"
      },
      "empty": {
        "text_1": "There are currently no available plans being offered at this destination.",
        "text_2": "Please search for other destinations."
      },
      "filtering": {
        "content": {
          "count": {
            "one": "Filter Results: %{count} Result",
            "other": "Filter Results: %{count}/%{total} Results"
          },
          "count_result": "Filter Results: %{count} Results",
          "title": "Available Plans"
        },
        "period": {
          "form": "Select a Travel Period",
          "title": "Filter by Travel Period"
        },
        "title": "Filter"
      }
    },
    "price_text": "JPY %{price}",
    "referral_code": {
      "cannot_be_used_for_the_referrers_own": "The referral code cannot be used for the referrer's own reservation.",
      "cannot_be_used_in_conjunction": "The referral code cannot be used in conjunction with other promotion codes.",
      "click_the_button": "Please enter the referrer's name and email address, then click the button to issue the referral code.",
      "copied_text": "Referral Code: [ %{code_value} ] \n\nDiscount Amount: %{amount_value} JPY\n\nNote: The code can only be used once per person.\n\n\"Japan Preschool Exchange\" is a program that connects local communities with families raising children, building a brighter future together. https://preschool-exchange.com/",
      "copy_completed": "Copy completed",
      "copy_the_referral_code": "Copy the referral code",
      "email_address": "Email Address",
      "errors": {
        "not_valid": "The information does not match our records. Please check the details and try again."
      },
      "first_name": "First name",
      "information_entry": "Referral information entry",
      "issuance_of_referral_code": "Issuance of referral code",
      "issue_the_referral_code": "Issue the referral code",
      "last_name": "Last name",
      "no_expiration_date": "There is no expiration date for the use of the referral code.",
      "please_check_it": "Your referral code has been issued. A confirmation email with your referral code has been sent to the email address you provided. Please check it.",
      "settings_to_allow_receipt_html": "When entering a mobile email address, there may be cases where emails do not arrive. Please ensure you configure your email settings to allow receipt from no-reply@kitchhike.com.",
      "the_same_code_will_be_displayed": "Even if you repeat the issuance process, the same code will be displayed. Please note this.",
      "usage_guidelines": "Usage Guidelines",
      "use_the_referral_code_only_once": "The referred person can use the referral code only once.",
      "you_can_share": "You can share your referral code with as many people as you like.",
      "your_referral_code": "Your referral code"
    },
    "registration": {
      "edit": {
        "email": "Representatives email address",
        "password": "Password",
        "submit": "Change",
        "title": "Change Email Address"
      }
    },
    "reservation": {
      "children_info": {
        "count": "Child #%{count}",
        "title": "Participating Child(ren)"
      },
      "heart_modal": {
        "check_text": "I agree to the Guidelines for Participating Families above.",
        "mission": "Our mission is to create a future where families can fully enjoy life and vibrant communities continue to thrive. To support the sustainability of this program, we ask you to follow the guidelines below to enjoy your stay.",
        "rule_1": "Respect the local community and express your gratitude.",
        "rule_2": "Understand and respect the philosophy of each childcare/educational facility.",
        "rule_3": "Follow good manners and stick to drop-off and pick-up times.",
        "rule_4": "Prioritize your child’s growth.",
        "rule_5": "Follow accommodation rules.",
        "rule_6": "Follow local living rules.",
        "sub_subscription": "Japan Preschool Exchange",
        "sub_title": "Guidelines for Participating Families",
        "submit": "Proceed to Reservation",
        "subscription": "Please review the following before proceeding with your application.",
        "text_1": "Japan Preschool/Elementary School Exchange is a local living experience, not a sightseeing tour. Please act respectfully as a member of the local community.",
        "text_2": "You will experience the daily activities of the childcare/educational facilities as they are. Interpretation devices may be used in some cases, but communication with teachers is primarily conducted in Japanese. Even if different from your own values, use this opportunity to learn and grow with your child.",
        "text_3": "While some facilities may offer extended hours, please adhere to the scheduled times. Excessive requests may result in the cancellation of your participation.",
        "text_4": "The goal of the program is to support your child’s healthy growth and enriching experiences within the community. The local childcare/educational facilities, accommodations, municipalities, and the entire city/town welcome your family with this in mind. If your main goal is relaxation, please consider other services.",
        "text_5": "Accommodations may include local-government-operated facilities as well as hotels and inns. Respect their rules and schedules, and avoid making excessive requests.",
        "text_6": "Please comply with local rules, such as waste sorting and traffic regulations. Be mindful of your behavior, and follow the rules and schedules when using local facilities or services to ensure a positive experience for everyone.",
        "title": "Reservation Terms Confirmation"
      },
      "progress": {
        "complete": "Complete",
        "confirm": "Confirm",
        "enter": "Enter"
      },
      "representative": {
        "occupation": {
          "company_employee": "Company employee",
          "company_employee_support": "Company employee (support staff)",
          "contract_temporary": "Contract employee / Temporary employee",
          "default": "Select",
          "employer": "Employer (Optional)",
          "house": "Housewife / Househusband",
          "income": "Are you a double income or single income family?",
          "item": "Occupation",
          "manager": "Manager / Executive",
          "medical": "Medical personnel",
          "no_answer": "Single Income",
          "other": "Other",
          "part_time": "Part-timer",
          "professional": "Professional (Certified Public Accountant, Lawyer, Certified Tax Accountant, Judicial Scrivener)",
          "public_employee": "Public employee (excluding teacher)",
          "retired": "Retired",
          "self_employ": "Self-employed",
          "student": "Student",
          "teacher": "Teacher",
          "title": "Occupation",
          "unemploy": "Unemployed",
          "yes_answer": "Double Income"
        }
      },
      "summary": {
        "accommodation": "Accommodation : %{accommodation}",
        "adult": {
          "one": "%{count} Adult",
          "other": "%{count} Adults"
        },
        "button": "View Plan Details",
        "child": {
          "one": "%{count} Child",
          "other": "%{count} Children"
        },
        "people": "Number of Guests : ",
        "period": "Period : %{start_date}~%{end_date}",
        "preschool": "Childcare/Educational Facility : %{preschool}"
      }
    },
    "reservation_complete": {
      "back_path": "Back to Bookable Destinations",
      "heading": "Reservation Request Submitted",
      "notes_1": "Please be aware that we may not be able to accommodate your reservation.",
      "notes_10": "Your account has been successfully created.",
      "notes_11": "A confirmation email has been sent for account verification,",
      "notes_12": "so please check your inbox.",
      "notes_2": "Please wait to arrange transportation or make any other preparations until your reservation is confirmed.",
      "notes_3": "We will now proceed with the final confirmation of availability with the preschool and accommodation. Once this is complete, your reservation will be confirmed. ",
      "notes_4": "A confirmation email with further instructions will be sent to your registered email address within three business days. Please wait for this email.",
      "notes_5": "Until your reservation is confirmed, please avoid making any arrangements for the following:",
      "notes_6": "Airplane or train tickets",
      "notes_7": "Rental car reservations",
      "notes_8": "Cancellation insurance, etc.",
      "title": "Your reservation is not yet confirmed."
    },
    "reservation_confirm": {
      "3dsecure": {
        "button": "Regarding 3D Secure Authentication",
        "modal": {
          "body": "To enhance security, 3D Secure authentication is now required when using your credit card.\nDuring the reservation request process, 3D Secure authentication will be conducted to verify that your card is valid for use.\n\nAdditionally, due to the implementation of 3D Secure, the transaction amount may appear as “JPY 0” on the authentication screen. However, authentication and payment processing are handled correctly.\n\nTo continue using our services with confidence, please review this information.",
          "title": "Regarding 3D Secure Authentication"
        }
      },
      "account": {
        "password": "Password",
        "title": "Account Information"
      },
      "caution": {
        "notes": "The reservation is not confirmed until the request is approved by the management. No charges will be incurred until the reservation is approved.",
        "title": "Reservation Requests"
      },
      "heading": "Confirmation of Reservation Details",
      "information": {
        "agree": {
          "check_box": "Agree",
          "notes": "To apply for a reservation request, you must agree to the above contents."
        },
        "cancellation": {
          "cancellation_policy_text": "Cancellation Policy",
          "notes_1": "If you cancel or change the date after submitting your reservation request, a cancellation fee will be charged according to the number of days. Please refer to the",
          "title": "Cancellation Policy"
        },
        "confirmation": {
          "notes": "Reservations are not confirmed at the time of submitting your reservation request. We will send a confirmation e-mail to you after we confirm with the childcare/educational facilities and the accommodation. Please note that your reservation may not be accepted depending on the situation.",
          "title": "Reservation Confirmation"
        },
        "other_item": {
          "cancel_text": "Cancellation Policy",
          "conditions_text": "Conditions of Transaction",
          "conditions_url": "https://japan.preschool-exchange.com/conditions/en",
          "family_text": "Basic Rules for Participating Families",
          "family_url": "https://preschool-exchange.com/family-rules",
          "privacy_policy_text": "Privacy Policy",
          "privacy_policy_url": "https://japan.preschool-exchange.com/privacy_policy/en",
          "terms_text": "Terms of Service",
          "terms_url": "https://japan.preschool-exchange.com/terms_of_service/en",
          "title": "Pre-Reservation Confirmation"
        },
        "request_to_family": {
          "notes_1": "We kindly ask all families, as members of the local community, to adhere to the",
          "notes_2": "Basic Rules for Participating Families.",
          "text": "Basic Rules",
          "title": "Request for All Families",
          "url": "https://preschool-exchange.com/family-rules"
        },
        "title": "Notes and Information"
      },
      "payment": {
        "card_number": "Credit Card Number",
        "expiration_date": "Expiration Date",
        "security_code": "Security Code",
        "title": "Payment Method"
      },
      "price": {
        "breakdown": "Breakdown",
        "breakdown_button": "View Price Breakdown",
        "button": "Request Reservation",
        "confirmation": "I confirm that I have read and agree to Conditions of Transaction, Privacy Policy, Terms of Service, Cancellation Policy, and  Basic Rules for Participating Families. I also agree to pay the total amount if my reservation request is approved by the management.",
        "processing": "Processing",
        "total": "Total Fee (tax included)"
      },
      "promotion": {
        "amount": "-JPY %{amount}",
        "applied": "%{code} applied",
        "button": "Apply",
        "code": "Referral Code / Promo Code (Optional)",
        "discount": "Promotional discount : ",
        "title": "Promotions"
      },
      "representative": {
        "address": {
          "country": "Country",
          "email": "E-mail",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "title": "Address"
        },
        "date_of_birth": "Date of Birth",
        "gender": "Gender",
        "name": "Name (in English)",
        "name_cn": "Name  (in Chinese, if any)",
        "relationship": "Relationship to the Child Participating the Program",
        "relationship_other_text": "Other (Optional)",
        "title": "Primary Contact"
      }
    },
    "reservation_email": {
      "letter_block_1": {
        "text_1": "This email address is for delivery only.",
        "text_2": "For enquiries, please contact:",
        "text_3": "support@hoikuen-ryugaku.zendesk.com",
        "text_4": "Thank you for your interest in applying for the Japan Preschool Exchange program.",
        "text_5": "Your reservation request has been received.",
        "text_6": "Your reservation has not been confirmed yet.",
        "text_7": "We will contact you by e-mail once your reservation has been confirmed.",
        "text_8": "Please understand in advance that we may not be able to confirm your reservation,",
        "text_9": "depending on the situation of childcare/educational facility."
      },
      "letter_block_2": {
        "text_1": "[Reservation request details]",
        "text_2": "Plan Name: %{plan_name}",
        "text_3": "Check-in Date: %{start_date}",
        "text_4": "Check-out Date: %{end_date}",
        "text_5": "Representative's Name: %{representative_name}",
        "text_6": "Total Fee: JPY %{total_fee}"
      },
      "letter_block_3": {
        "text_1": "We will now confirm the reservation details with the host accommodation",
        "text_10": "※If your account registration verification has not been completed, please complete the verification process using the email sent to you separately.",
        "text_11": "Login URL: %{login_url}",
        "text_12": "Cancellation or Change of Reservation",
        "text_13": "If you wish to cancel or change your reservation, a cancellation fee will be charged.",
        "text_14": "Please refer to our cancellation policy for details.",
        "text_15": "We sincerely hope that the Japan Preschool Exchange program will be a wonderful experience for your child(ren) and your family.",
        "text_2": "and childcare/educational facility and make final arrangements,",
        "text_3": "and let you know via your registered e-mail address in about 5 business days.",
        "text_4": "Please note that we may offer online consultation sessions depending on your reservation request status and other circumstances.",
        "text_5": "If you have any preferences, we are also open to conducting online consultation sessions.",
        "text_6": "Please feel free to let us know.",
        "text_7": "[About MyPage]",
        "text_8": "You can check your reservation details from MyPage.",
        "text_9": "Once your reservation request is approved, you can also review the necessary procedures via the ToDo List on your MyPage."
      },
      "letter_block_4": {
        "text_1": "Japan Preschool Exchange Operation Desk",
        "text_2": "Website: https://preschool-exchange.com/",
        "text_3": "E-mail: support@hoikuen-ryugaku.zendesk.com",
        "text_4": "Please allow 3 to 4 business days for a reply (excluding Saturdays, Sundays, and holidays).",
        "text_5": "Management Company: KitchHike, Inc.",
        "text_6": "4-13-9 ROUTE 89 BLDG. 4F Higashi Ueno, Taito-ku, Tokyo",
        "text_7": "https://kitchhike.com"
      }
    },
    "reservation_input": {
      "accordion": {
        "icon_message": "There are fields that have not been filled in.",
        "message_no_selected": "No Selection",
        "message_not_input": "No Entries"
      },
      "children_info": {
        "allergy": {
          "allergenic_foods": {
            "beans_grains_nuts": "Beans, Grains, Seeds",
            "default": null,
            "egg": "Egg",
            "fruits": "Fruits",
            "meat_fish": "Meat and Fish",
            "milk": "Milk and dairy products",
            "other": "Other",
            "shellfish": "Crustaceans",
            "title": "Please select the foods that cause the allergies.",
            "validation_title": "an answer",
            "wheat": "Wheat"
          },
          "allergy_causes": {
            "default": null,
            "title": "Please specify the allergens.",
            "validation_title": "an answer"
          },
          "allergy_elimination": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Do you wish to have allergen-free meals provided?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "availability": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Does this child have any food allergies?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "foodrequest": {
            "default": null,
            "title": "Fill in any special requests for meals.",
            "validation_title": "an answer"
          },
          "foodrequest_yes_or_no": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Is there any special consideration needed regarding meals due to religious reasons or a plant-based diet (such as vegetarianism)?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "nonfood_allergies": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Does this child have any non-food allergies?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "other_food_name": {
            "default": null,
            "title": "If other, please specify the ingredients.",
            "validation_title": "an answer"
          },
          "question1": {
            "confirmation": "Confirmed",
            "title": "Please consult with the childcare/educational facility directly at the time of the online pre-meeting and follow the necessary procedures if your child has any special dietary needs. Please note that the availability and level of accommodation for allergen-free meals may vary by facility.",
            "validation_title": "the confirmation box"
          },
          "symptoms": {
            "default": null,
            "description": "Please be sure to provide any considerations or necessary accommodations in daily life, as well as details if anaphylaxis is present.",
            "title": "Please describe the allergy symptoms in detail.",
            "validation_title": "an answer"
          },
          "title": "Meal and Allergy Information"
        },
        "base": {
          "title": "Basic Information"
        },
        "enrollment_school": {
          "school_name": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Please name of the school your child currently attends.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "school_type": {
            "default": "Please select",
            "national": "National",
            "private": "Private",
            "public": "Public",
            "title": "Please select the type of school your child currently attends.",
            "validation_title": "an answer"
          },
          "title": "Educational Experience"
        },
        "life_habit": {
          "developmentaldisorder": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Has your child ever been diagnosed with a developmental disability?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "diagnosis": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Please specify the diagnostic name.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "language": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Language(s) spoken by this child",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "medical_history": {
            "default": "Please select",
            "description": "Eamples: Febrile seizures, Elbow disorder, Epilepsy, Asthma, Kawasaki Disease, or any history of hospitalization and surgery, etc.",
            "no_answer": "No",
            "title": "Does this child have any history of illness, surgery, injury, or treatment?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "medical_history_details": {
            "default": "Please select",
            "description": "Please provide details on the disease, frequency, age at onset, and any current medication. (e.g., Febrile seizures, twice, onset at 18 months, current medication: none).",
            "no_answer": "No",
            "title": "Please specify the details of medical history.",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "opportunitynurseryschool": {
            "default": "Please select",
            "no_answer": "No",
            "title": "Has this child attended any childcare/educational facilities for more than 3 days a week?",
            "validation_title": "an answer",
            "yes_answer": "Yes"
          },
          "title": "Health and Lifestyle"
        },
        "planned_participation": {
          "default": "Please select",
          "elementary_school": "Japan Elementary Exchange and Camp Programs",
          "nursery_school": "Japan Preschool Exchange",
          "title": "Program Type",
          "validation_title": "Program Type"
        }
      },
      "heading": "Enter reservation details",
      "modal": {
        "breakdown": {
          "adult_rate": "Adult Rate (1 night)",
          "basic_price": "Basic Price",
          "child_rate": "Child Rate (1 night)",
          "elementary_aboard": "Elementary Exchange and Camp Programs : ",
          "not_and_elementary": "Not in Program (Aged 7-12) : ",
          "not_and_toddler": "Not in Program (Aged 0-6) : ",
          "nursery_aboard": "Preschool Exchange Program : ",
          "option_price": "Option Price (tax included)",
          "plan_price": "Plan Price (tax included)",
          "price_number": "JPY %{unit_price} × %{number}",
          "promotion": "Promotions",
          "title": "Price Breakdown",
          "total": "Total Fee (tax included)"
        },
        "close": "Close",
        "plan_detail": {
          "accommodation": {
            "title": "Accommodation",
            "type": "Accommodation Type : %{type}"
          },
          "adult": {
            "one": "%{count} Adult,",
            "other": "%{count} Adults,"
          },
          "people": "Number of Guests : ",
          "period": "Period : %{start_date}~%{end_date}",
          "preschool": {
            "eligibility": "Eligibility : %{eligibility}",
            "title": "Childcare/Educational Facility"
          },
          "preschoolers": {
            "one": "Preschool Participants %{count} Child",
            "other": "Preschool Participants %{count} Children"
          },
          "preschoolers_1": {
            "one": "Not in Program (Aged 0-6) %{count} Child",
            "other": "Not in Program (Aged 0-6) %{count} Children"
          },
          "students": {
            "one": "Elementary School Participants %{count} Child",
            "other": "Elementary School Participants %{count} Children"
          },
          "students_1": {
            "one": "Not in the Program (Aged 7-12) %{count} Child",
            "other": "Not in the Program (Aged 7-12) %{count} Children"
          },
          "title": "Plan Details"
        }
      },
      "option_select": {
        "close": "Close",
        "label": "Option Descriptions",
        "notes": "Review the Option Descriptions for details of the options.",
        "title": "Option Selection (Optional)"
      },
      "price": {
        "breakdown": "Breakdown",
        "button": "Proceed to Confirmation",
        "total": "Total Fee"
      },
      "representative": {
        "account": {
          "account_notes_1": "You will receive an identity verification email once your reservation request is complete.",
          "account_notes_2": "After verification is complete, an account for logging into your My Page will be created.",
          "login": "Log In",
          "login_link": "＞If you already have an account, click here",
          "login_title": "Login",
          "password": "Password",
          "password_confirmation": "Confirm Password",
          "password_description": "Password must be 8 to 64 characters long and include at least one lowercase letter and one number.",
          "reset_password": "Forgot your password? Click here",
          "title": "Account Information"
        },
        "address": {
          "building": "Building name, etc. (optional)",
          "city_town_village": "City/Town/Village",
          "country": "Country",
          "email": "E-mail",
          "email_notes_1": "Enter the e-mail address at which you would like to receive the reservation confirmation e-mail. ",
          "email_notes_2": "Please make sure that you can receive e-mails from no-reply@kitchhike.com.",
          "phone_notes_1": "Please enter letters and numbers only, without hyphens (-).",
          "phone_notes_2": "Example: 123-456-7890 → 1234567890",
          "phone_number": "Phone Number",
          "postal_code": "Postal Code",
          "postal_code_notes_1": "Please enter letters and numbers only, without hyphens (-).",
          "postal_code_notes_2": "Example: 123-4567 → 1234567",
          "prefecture": "State/Province",
          "street_address": "Street number/Other address",
          "title": "Address"
        },
        "date_of_birth": "Date of Birth",
        "first_name": "First Name (in English)",
        "first_name_cn": "First Name  (in Chinese, if any)",
        "gender": {
          "female": "Female",
          "male": "Male",
          "other": "Other",
          "title": "Gender"
        },
        "last_name": "Last Name (in English)",
        "last_name_cn": "Last Name  (in Chinese, if any)",
        "relationship": {
          "brother_sister": "Brother / Sister",
          "default": "Select",
          "father": "Father",
          "grand_father": "Grandfather",
          "grand_mother": "Grandmother",
          "mother": "Mother",
          "other": "Other",
          "other_text": "Other (Optional)",
          "title": "Relationship to the Child Participating the Program"
        },
        "sub_title": "Basic Information",
        "title": "Primary Contact"
      }
    },
    "reservation_mailer": {
      "reservation_email": {
        "from": "Japan Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
        "subject": "Thank you for your reservation request [Japan Preschool Exchange]"
      }
    },
    "reset_password_mailer": {
      "from": "Japan Preschool Exchange Operation Desk <no-reply@kitchhike.com>",
      "subject": "Please Reset Your Password [Japan Preschool Exchange]"
    },
    "review": {
      "posted_date": "Posted on: %{date}",
      "usage_count": "%{count} time in the program"
    },
    "review_index": {
      "back_path": "Back",
      "children_age_text": "Children Age",
      "empty": "Family voices not found.",
      "guest_house": "Accommodation",
      "message_locals": "Message to Local People",
      "message_preschool": "Message to Preschool Teachers",
      "number_of_people": {
        "adult": {
          "one": "%{count} Adult",
          "other": "%{count} Adults"
        },
        "child": {
          "one": "%{count} Child",
          "other": "%{count} Children"
        },
        "title": "Number of People",
        "total": {
          "one": "%{count} Person",
          "other": "%{count} People"
        }
      },
      "nursery": "Educational Facility",
      "read_more": "Read more",
      "stay_days": {
        "content": {
          "one": "%{count} Week (From %{date})",
          "other": "%{count} Weeks (From %{date})"
        },
        "title": "Period"
      },
      "translation_note": "This review is AI-translated from Japanese; some expressions may be inaccurate."
    },
    "support": {
      "array": {
        "last_word_connector": ", and ",
        "two_words_connector": " and ",
        "words_connector": ", "
      }
    },
    "time": {
      "am": "am",
      "formats": {
        "default": "%Y/%m/%d %H:%M",
        "long": "%B %d, %Y %H:%M",
        "month": "%b",
        "short": "%d %b %H:%M",
        "year": "%Y",
        "year_and_month": "%b %Y",
        "year_and_month_and_day": "%-B %-d, %Y"
      },
      "pm": "pm"
    },
    "todo_reminder": {
      "three_days_before_reminder": {
        "link": "[Check your ToDo List] ",
        "subject": "Upcoming Due Date on ToDo List [Japan Preschool Exchange]",
        "text1": "Greetings from the Japan Preschool Exchange Operation Desk.\nWe hope your preparations for your stay are going smoothly.\n",
        "text2": "◾️ Tasks Approaching Due Date",
        "text3": "Please make sure to complete these tasks in time. Once you’ve completed the necessary steps, you’ll be ready to smoothly proceed to the next stage.",
        "text4": "If you have any questions or need support, please don't hesitate to contact the Preschool Exchange Operation Desk.",
        "text5": "Best regards,",
        "time_limit": "Due Date: %{time_limit}"
      },
      "time_limit_reminder": {
        "subject": "Overdue ToDo List [Japan Preschool Exchange]",
        "text1": "The due date for one of the tasks we previously informed you about has passed, but it appears that it has not yet been completed.",
        "text2": "◾️ Incomplete Task",
        "text3": "Please note that if the task remains incomplete, you will not be able to proceed to the next step, which may affect your travel preparations. Kindly log in to your MyPage and complete the necessary steps as soon as possible."
      }
    },
    "top": {
      "category_list": {
        "all": "All",
        "animal_contact": "Animal contact",
        "baby_friendly": "Baby-friendly",
        "car_free_accessible": "Car-free",
        "developmental_support": "Developmental Support",
        "elementary_ok": "Elementary OK",
        "english_available": "English available",
        "english_education": "English education",
        "farm_experience": "Farm experience",
        "food_education": "Food Education",
        "forest_play": "Forest play",
        "historic_streets": "Historic streets",
        "home_town": "Home town tax",
        "mud": "Mud",
        "pets_allowed": "Pets Allowed",
        "preschool_photo_sharing": "Preschool photo sharing",
        "sea_play": "Sea play",
        "snow_play": "Snow play",
        "stay_with_meals": "Stay with meals",
        "walk_to_preschool": "Walk to preschool",
        "walkable_access": "Walkable access",
        "with_coworking": "With coworking"
      },
      "component": {
        "minimum_price": "From JPY %{minimum_price}",
        "people": "2 Adults, 1 Child"
      },
      "empty": {
        "text_1": "There are no plans that match your search criteria.",
        "text_2": "Please change the time period.",
        "text_3": "We cannot find a destination that matches your search criteria.",
        "text_4": "Please change your search criteria."
      },
      "filtering": {
        "area": {
          "title": "Destination Area"
        },
        "button": {
          "apply": "Apply",
          "clear": "Clear"
        },
        "class": {
          "age": {
            "age_text": "%{age}-Year-Old Class",
            "asterisk": "(*)",
            "birth_period": "%{start_date} - %{end_date}",
            "birth_period_header": "Date of Birth",
            "caution": "(*) The acceptable age varies depending on their age in months. Please refer to the detailed page for each destination for more information.",
            "class_header": "Class",
            "label": "Class Age Table",
            "notes": "Classes are determined according to the Japanese school year calendar. Please confirm your child's class based on the timing of participation and the table below.",
            "period": "For those participating in the Japan Preschool Exchange from April 1, %{start} to March 31, %{end}:",
            "year": "%{year} School Year"
          },
          "option": "%{age} Year Olds Class",
          "text": "Please select your child's class.",
          "title": "Class"
        },
        "content": {
          "count": {
            "one": "Filter Results: %{count} Result",
            "other": "Filter Results: %{count} Results"
          },
          "title": "Destinations List"
        },
        "criteria": "Search By",
        "season": {
          "form": "Select the year and month",
          "text": "Select the year and month you wish to travel.",
          "title": "Travel Period"
        },
        "title": "Filter"
      },
      "heading": "Bookable Destinations",
      "modal_search": {
        "class": {
          "0_year_old_class": "0 Year Old Class",
          "1_year_old_class": "1 Year Olds Class",
          "2_year_old_class": "2 Year Olds Class",
          "3_year_old_class": "3 Year Olds Class",
          "4_year_old_class": "4 Year Olds Class",
          "5_year_old_class": "5 Year Olds Class",
          "no_attendance": "Not in the Program"
        },
        "default_placeholder": "Filter by Age, Period, and Region",
        "header": "Filter",
        "local_transportation": {
          "option_1": "Accessible Without a Car",
          "title": "Local Transportation",
          "value": "car_free"
        },
        "month": "",
        "month_number_from": " month~",
        "notice_txt_1": "※ Please enter the class for the period when your child will participate. If the timing is undecided, please enter their current class.",
        "plan_month": {
          "title": "Select the year and month you wish to participate"
        },
        "region": {
          "title": "Destination Area"
        },
        "search_region": {
          "chugoku_shikoku": "Chugoku/Shikoku",
          "hokkaido": "Hokkaido",
          "hokuriku_koshinetsu": "Hokuriku/Koshinetsu",
          "kanto": "Kanto",
          "kyushu_okinawa": "Kyushu/Okinawa",
          "tohoku": "Tohoku",
          "tokai_kinki": "Tokai/Kinki"
        },
        "search_text": {
          "placeholder": "Search by Preschool / Educational Facility or Destination Area"
        },
        "stay_day": {
          "subtitle": "Select Duration",
          "title": "Period"
        },
        "title": "Filter",
        "week": " week",
        "year": " year"
      },
      "subheading": "Below are destinations that are available for reservation."
    },
    "url": {
      "cancel_policy": "https://preschool-exchange.com/stipulation#cancel-policy",
      "conditions": "https://japan.preschool-exchange.com/conditions/en",
      "inquiries": "mailto:support@hoikuen-ryugaku.zendesk.com",
      "privacy_policy": "https://japan.preschool-exchange.com/privacy_policy/en",
      "stipulation": "https://preschool-exchange.com/stipulation",
      "terms_of_use": "https://preschool-exchange.com/terms-of-use",
      "travel_deal_details": "https://japan.preschool-exchange.com/travel_transaction_details/en"
    },
    "views": {
      "confirmation": {
        "address": "Address",
        "basic_information": "Basic Information",
        "billing_information": "Billing Information",
        "birth_date": "Date of birth",
        "children_information": "Participating Child(ren)",
        "confirmation": "Review Your Information",
        "contact_information": "Contact Information",
        "emergency_contact_during_stay": "Stay Emergency Contact",
        "exercise_section": "Other (For Ages 0-1 Only)",
        "family_confirmation": "Register Family Information",
        "family_information": "Other Accompanying Guest(s)",
        "full_name": "Full Name (in Chinese, if any)",
        "full_name_reading": "Full Name",
        "gender": "Gender",
        "interview_question": "Interview/Survey",
        "living_conditions": "Health and Lifestyle",
        "meal_and_allergy_information": "Meal and Allergy Information",
        "money_unit": "JPY",
        "no_input": "Not Entered",
        "occupation": "Occupation",
        "option": "Option",
        "people_unit": "Guest",
        "primary_contact_information": "Primary Contact",
        "reservation_information": "Reservation Information",
        "school_information": "The school your child currently attends"
      },
      "edit": "Edit",
      "family_master": {
        "confirmed": "confirmed",
        "headings": {
          "address": "Address",
          "allergy_information": "Allergy Information",
          "basic_information": "Basic Information",
          "contact_information": "Contact Information",
          "exercise_section": "Please fill in the following information only if the child is 0 to 1 year old.",
          "living_conditions": "Health and Lifestyle",
          "school_information": "School Information",
          "stay_with": "Person staying with",
          "work": "Occupation"
        },
        "messages": {
          "medical_history_details_note": "※ Please provide details on the disease, frequency, age at onset, and any current medication. (e.g., Febrile seizures, twice, onset at 18 months, current medication: none).",
          "medical_history_note": "※ Examples: febrile convulsions, elbow dislocation, epilepsy, asthma, Kawasaki disease, history of hospitalization or surgery, etc.",
          "special_requests": "※ For reasons other than food allergies (e.g., religious reasons or Halal requirements)",
          "symptoms_note": "Please be sure to provide the severity of allergies, any necessary considerations, details about anaphylactic symptoms, and any medications if applicable."
        },
        "select": "Please select"
      },
      "flash": {
        "alert": {
          "conditional_requirement_answer": "Please answer the question.",
          "family_confirmation": {
            "no_input": "There are fields that have not been filled in."
          },
          "nursery_meeting": {
            "full": "All interview dates are full.",
            "select": "Please select a date."
          },
          "todo_uploads": "Please upload any file."
        }
      },
      "modal_message": {
        "back": "Back",
        "complete": "Complete",
        "final_confirm": "Final Confirmation",
        "final_confirm_message": "Proceed with submission?",
        "final_confirm_message_2": "Have you completed the task? Press 'Complete' to update the status.",
        "final_confirm_message_3": "Proceed with submission?  No further revisions allowed.",
        "submission": "Submit",
        "submit": "Submit"
      },
      "mypage": {
        "cancel_fee": "Cancel Fee : ",
        "cancelled": "Cancelled",
        "form": {
          "children_form": "Participating Child(ren)",
          "completions": {
            "done": "Submitted",
            "thank_you": "Task completed. Well done!",
            "top": "Back to Top"
          },
          "exist_information": "Information You Have Previously Registered",
          "family_form": "Other Accompanying Guest(s)",
          "reservations_form": "Reservation Information",
          "todo_uploads": {
            "attachment": "Attachment",
            "file_size_error": "The maximum size of one file is 20MB.",
            "upload_file": "File Upload",
            "uploaded_file_1": "Attachment1"
          }
        },
        "next_plan": "Haven't decided on your next destination yet?",
        "next_plan_message": "Every season offers unique experiences across each region. Let's start planning your next adventure!",
        "planned_visit": "Upcoming",
        "reservation_status": {
          "cancelled": "Cancelled",
          "completed": "Completed",
          "processing": "Processing",
          "upcoming": "Upcoming"
        },
        "search_study_destination": "Find a destination",
        "visited": "Completed"
      },
      "reservation_request": {
        "confirmation_of_reservation": "See Reservation Details >",
        "confirmed": "confirmed",
        "headings": {
          "emergency_contact_during_stay": "Emergency Contact",
          "information_during_your_stay": "Information during your stay",
          "interview_question": "Media Coverage",
          "reservation_information": "Reservation Information"
        },
        "lets_check": "Check Before You Go",
        "lets_check_bookmark": "Check Your Handbook",
        "lets_check_message": "You can find the Japan Preschool Exchange Handbook here, which includes essential information you need before departure, such as what to bring, accommodation details, and check-in instructions.",
        "messages": {
          "check_in_time_note": "※ If your check-in time changes on the day of your arrival, please be sure to contact the accommodation directly.",
          "emergency_contact_during_stay_note": "In case we need to contact you in an emergency during your stay, we will call this number.",
          "emergency_contact_note": "* Please enter a reachable contact number during your stay. This number will be shared with the accommodation and the childcare/educational facility."
        },
        "plans": {
          "accommodation": "Accommodation : %{room_name}",
          "adult": {
            "one": "%{count} Adult,",
            "other": "%{count} Adults,"
          },
          "child": {
            "one": "%{count} Child",
            "other": "%{count} Children"
          },
          "people": "Number of Guests : ",
          "period": "Period : %{start_date} - %{end_date}",
          "preschool": "Childcare/Educational Facility : %{nursery_name}",
          "preschool_1": "Childcare/Educational Facility : %{nursery_name}",
          "preschool_2": "Childcare/Educational Facility 2 : %{nursery_name}"
        },
        "todo_list": "ToDo List"
      },
      "reservation_request_todo": {
        "arrange_an_interview_date": "Please schedule an interview.",
        "asap": "ASAP",
        "date": "Date : %{date}",
        "done": "Done",
        "soon": "Soon",
        "submission_due_date": "Due : %{date}"
      },
      "todo": {
        "submission_deadline": "Submission By : %{date}"
      }
    }
  },
  "ja": {
    "account": {
      "password": {
        "edit": {
          "current_password": "現在のパスワード",
          "current_password_note": "変更を確認するために現在のパスワードが必要です",
          "minimum_length": "（%{count}文字以上）",
          "new_password": "パスワード",
          "new_password_note": "変更しない場合は空欄のままにしてください",
          "password_confirmation": "パスワード（確認用）",
          "submit": "変更する",
          "title": "パスワード変更"
        },
        "update": {
          "success": "パスワードを更新しました。"
        }
      },
      "profile": {
        "edit": {
          "first_name": "名",
          "first_name_reading": "名（フリガナ）",
          "last_name": "姓",
          "last_name_reading": "姓（フリガナ）",
          "phone_number_note_1": "ハイフン（-）を入れず、数字のみで入力してください。",
          "phone_number_note_2": "(例：123-456-7890 → 1234567890)",
          "postal_code_note_1": "ハイフン（-）を入れず、数字のみで入力してください。",
          "postal_code_note_2": "(例：123-4567 → 1234567)",
          "submit": "変更を保存する",
          "title": "プロフィール編集"
        },
        "show": {
          "address": "住所",
          "basic_information": "基本情報",
          "change_password": "パスワードを変更する",
          "contact_information": "連絡先",
          "edit": "編集する",
          "full_name": "姓名（漢字）",
          "full_name_japanese": "姓名（ふりがな）",
          "logout": "ログアウトする",
          "occupation": "職業",
          "password": "パスワード",
          "primary_contact_information": "代表者情報",
          "title": "アカウント設定"
        },
        "update": {
          "success": "プロフィールを更新しました。"
        }
      }
    },
    "account_confirmation": {
      "email": "メールアドレス",
      "submit": "確認メールを再送信する",
      "title": "確認メール再送信"
    },
    "account_confirmation_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "ご登録いただいたメールアドレスでのアカウント作成が完了しました。",
        "text_10": "※このURLの有効期限は24時間です。",
        "text_11": "期限を過ぎた場合は、%{confirmation_resend_link}から本人確認メールの再送信をしてください。",
        "text_12": "こちら",
        "text_2": "ご予約の確認や手続きを進めるためには、以下のURLにアクセスし本人確認を完了させてください。",
        "text_3": "本人確認が完了すると、マイページにログインできるようになります。",
        "text_4": "本人確認用URL",
        "text_5": "次のステップ",
        "text_6": "1. 上記のURLにアクセスし、本人確認を完了してください。",
        "text_7": "2. マイページにログインし、予約内容を確認いただけます。",
        "text_8": "3. 予約リクエストが承認されましたら、マイページのやることリストから必要な手続きをご確認いただけます。",
        "text_9": "ご不明な点などありましたら、保育園留学運営事務局にお問い合わせください。"
      },
      "letter_block_3": {
        "text_1": "保育園留学 運営事務局",
        "text_2": "HP. https://hoikuen-ryugaku.com/",
        "text_3": "mail. support@hoikuen-ryugaku.zendesk.com",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "東京都台東区東上野4-13-9 ROUTE 89 BLDG. 4F",
        "text_7": "https://kitchhike.com"
      }
    },
    "account_confirmation_instructions_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "以下のURLにアクセスし本人確認を完了させてください。",
        "text_2": "本人確認が完了すると、マイページにログインできるようになります。",
        "text_3": "本人確認用URL",
        "text_4": "ご不明な点などありましたら、保育園留学運営事務局にお問い合わせください。"
      },
      "letter_block_3": {
        "text_1": "保育園留学 運営事務局",
        "text_2": "HP. https://hoikuen-ryugaku.com/",
        "text_3": "mail. support@hoikuen-ryugaku.zendesk.com",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "東京都台東区東上野4-13-9 ROUTE 89 BLDG. 4F",
        "text_7": "https://kitchhike.com"
      }
    },
    "account_confirmation_mailer": {
      "confirmation_instructions": {
        "from": "保育園留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "アカウント認証を完了してください【保育園留学 運営事務局】"
      },
      "custom_welcome_instructions": {
        "from": "保育園留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "本人確認をし、アカウント登録を完了してください【保育園留学 運営事務局】"
      }
    },
    "account_reset_password_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com"
      },
      "letter_block_2": {
        "text_1": "パスワード変更のリクエストを受け付けました。",
        "text_2": "以下のリンクから新しいパスワードを設定してください。",
        "text_3": "パスワードを変更する"
      },
      "letter_block_3": {
        "text_1": "保育園留学 運営事務局",
        "text_2": "HP. https://hoikuen-ryugaku.com/",
        "text_3": "mail. support@hoikuen-ryugaku.zendesk.com",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "東京都台東区東上野4-13-9 ROUTE 89 BLDG. 4F",
        "text_7": "https://kitchhike.com"
      }
    },
    "activemodel": {
      "attributes": {
        "kintone/family_master": {
          "allergenic_foods": "アレルギーの原因となる食品",
          "allergy_causes": "アレルギーの原因となるもの",
          "allergy_elimination": "除去食の対応・その他特別な対応が必要な場合の確認",
          "appetite_food": "食欲",
          "baby_food": "離乳食",
          "birth_date": "生年月日",
          "breastfeeding": "授乳",
          "business": "職業",
          "company_name": "勤務先",
          "country": "国名",
          "developmentaldisorder": "今までに発達障がいと診断されたことはありますか",
          "diagnosis": "診断名を教えてください",
          "email_address": "メールアドレス",
          "exercise": "運動",
          "family_relationship": "保育園留学をするお子さまとの続柄",
          "family_relationship_other": "続柄がその他の場合はご関係をご記入ください",
          "favorite_playing": "好きな遊び",
          "first_name": "名",
          "first_name_reading": "めい",
          "food_allergies_yes_or_no": "食物アレルギーはありますか？",
          "foodrequest": "食事についてスペシャルリクエスト",
          "foodrequest_yes_or_no": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮が必要ですか",
          "full_name": "姓名（漢字）",
          "full_name_reading": "姓名（ふりがな）",
          "gender": "性別",
          "language": "お子さまの使用言語",
          "last_name": "姓",
          "last_name_reading": "せい",
          "medical_history": "これまでに経験した病気や手術、怪我、治療歴がありますか",
          "medical_history_details": "既往歴の詳細",
          "municipalities": "市区町村",
          "name_of_building": "建物名など",
          "napping": "お昼寝",
          "nonfood_allergies": "食物以外のアレルギーがありますか",
          "opportunitynurseryschool": "今まで、週３日以上の通園経験はありますか",
          "other_food_name": "その他の場合、食材を記入してください",
          "personality": "良いと思う性質・気になる性質",
          "phone_number": "電話番号",
          "planned_participation": "留学先",
          "postal_code": "郵便番号",
          "prefecture": "都道府県",
          "question1": "除去食の対応・その他特別な対応が必要となる場合は、必ず面談時に先生へ直接相談し、各施設の必要な手続きを行ってください。なお、対応の可否や対応レベルは各施設によって異なりますので、予めご了承ください。",
          "same_as_representative_address": "代表者と同じ",
          "same_as_representative_phone_number": "代表者と同じ",
          "school_name": "在籍学校名",
          "school_type": "学校の種類",
          "symptoms": "アレルギーの症状",
          "things_that_need_attention": "発達の遅れや集団生活を送る上で配慮が必要なこと",
          "toilet": "排泄",
          "town_area_street_address": "町域・番地",
          "underwear": "下着"
        },
        "kintone/representative_user_master": {
          "birth_date": "生年月日",
          "building": "建物名など",
          "business": "職業",
          "co_workers": "共働きか",
          "company_name": "勤務先",
          "country": "国名",
          "email_address": "代表者メールアドレス",
          "family_relationship": "留学するお子さまとの続柄",
          "first_name": "名",
          "first_name_reading": "めい",
          "gender": "性別",
          "last_name": "姓",
          "last_name_reading": "せい",
          "municipalities": "市区町村",
          "number_of_appointments": "予定数",
          "number_of_cancellations": "キャンセル数",
          "number_of_reservations": "予約数",
          "other": "続柄がその他の場合",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "prefecture": "都道府県",
          "prefecture_text": "都道府県",
          "town": "町域・番地"
        },
        "kintone/reservation_request": {
          "billing_fee": "請求合計",
          "billing_fee_total": "請求合計",
          "cancel_fee": "キャンセル料",
          "cancel_processed_date": "キャンセル日",
          "charge_date": "決済日",
          "check_in_time": "宿泊施設への到着予定時刻",
          "discount_amount": "ディスカウント料金",
          "emergency_contact1": "緊急連絡先①",
          "emergency_contact2": "緊急連絡先②",
          "end_of_stay": "滞在終了日",
          "guardian_name": "送迎をする保護者の氏名",
          "id": "予約番号",
          "interview": "滞在中・体験後インタビューやメディアの取材に応じていただけますか？",
          "number_of_adults": "大人人数合計",
          "number_of_preschoolers": "未就学児人数(留学あり)",
          "number_of_preschoolers_1": "未就学児人数(留学なし)",
          "number_of_students": "小学生人数(留学なし)",
          "number_of_students_1": "小学生人数(留学あり)",
          "nursery_name": "留学施設",
          "nursery_name_0": "留学施設②",
          "option_count": "オプション数量",
          "option_name": "オプション名",
          "option_price": "オプション料金",
          "option_total": "オプション合計(税込)",
          "plan_name": "プラン名",
          "prtrait_right": "地域の広報や保育留学の公式サイト、雑誌やテレビ等のメディアに、お子さまの写真を掲載することについて、ご了解いただけますか？",
          "room_name": "宿泊施設",
          "route": "予約のきっかけを教えてください",
          "route_others": "その他を選択した場合に入力してください",
          "start_of_stay": "滞在開始日",
          "total_number_of_people": "滞在人数合計"
        },
        "questionnaire": {
          "absent_days": "今回の滞在期間中、留学先の保育園をお休み・早退した日がある場合は、お休み・早退した日数を教えてください",
          "feedback_on_omutei": "（「はい」と回答された方）おむかえテイクアウトのご感想を聞かせてください",
          "food_cost": "現地での食費",
          "other_cost": "その他の費用",
          "reason_for_moving_interest": "(移住に関心がある旨の回答をされた方）移住に関心を持った理由をお答えください",
          "reason_for_recommendation": "上記質問で回答した点数の理由を聞かせてください",
          "reason_for_using_nouzei": "（「はい」と回答された方）留学先納税を利用した理由を教えてください",
          "reason_for_using_omutei": "（「はい」と回答された方）おむかえテイクアウトを利用した理由を教えてください",
          "region_suggestion": "今回留学した地域で改善してほしい点やご要望があれば聞かせてください",
          "satisfaction": "保育園留学全体の満足度を教えてください",
          "service_request": "今後、保育園留学の中で、こういうこともできたらいいと思うリクエストはありますか？",
          "service_suggestion": "保育園留学サービスとして改善してほしい点やご要望を聞かせてください",
          "transportation_cost": "現地での交通費",
          "used_nouzei": "留学前に、留学先納税をご利用されましたか",
          "used_omutei": "滞在中におむかえテイクアウトをご利用されましたか",
          "want_to_move": "今回留学した地域に移住したいと思いましたか",
          "want_to_recommend": "保育園留学をお子さんがいる親しい友人や家族にすすめたいと思いますか",
          "want_to_repeat": "また保育園留学に行きたいと思いますか",
          "want_to_repeat_nouzei": "（「はい」と回答された方）次回留学する際も、留学先納税を使いたいと思いますか？理由と合わせて教えてください"
        }
      },
      "errors": {
        "messages": {
          "blank": "を入力してください",
          "inclusion": "を選択してください",
          "too_long": "は%{count}文字以内で入力してください"
        }
      },
      "models": {
        "kintone": {
          "family_master": "家族マスター",
          "representative_user_master": "代表者マスター"
        }
      }
    },
    "activerecord": {
      "attributes": {
        "review": {
          "comment": "保育園留学のご感想",
          "message_to_locals": "宿・地域の方へのメッセージ",
          "message_to_teacher": "園の先生方へのメッセージ",
          "publication_status": "いただいた感想と先生・地域の方へのメッセージをホームページ等でご紹介してもよろしいですか",
          "title": "保育園留学のご感想タイトル"
        },
        "user": {
          "confirmation_sent_at": "パスワード確認送信時刻",
          "confirmation_token": "パスワード確認用トークン",
          "confirmed_at": "パスワード確認時刻",
          "created_at": "作成日",
          "current_password": "現在のパスワード",
          "current_sign_in_at": "現在のログイン時刻",
          "current_sign_in_ip": "現在のログインIPアドレス",
          "email": "メールアドレス",
          "encrypted_password": "暗号化パスワード",
          "failed_attempts": "失敗したログイン試行回数",
          "last_sign_in_at": "最終ログイン時刻",
          "last_sign_in_ip": "最終ログインIPアドレス",
          "locked_at": "ロック時刻",
          "password": "パスワード",
          "password_confirmation": "パスワード（確認用）",
          "remember_created_at": "ログイン記憶時刻",
          "remember_me": "ログインを記憶する",
          "representative_building": "建物名など（任意）",
          "representative_business": "職業",
          "representative_co_workers": "共働きかどうか",
          "representative_company_name": "勤務先（任意）",
          "representative_country": "国",
          "representative_day": "日",
          "representative_family_relationship": "留学する子どもとの続柄 ",
          "representative_first_name": "名",
          "representative_first_name_reading": "名（フリガナ）",
          "representative_gender": "性別",
          "representative_last_name": "姓",
          "representative_last_name_reading": "姓（フリガナ）",
          "representative_month": "月",
          "representative_municipalities": "市町村",
          "representative_other": "その他（任意）",
          "representative_phone_number": "電話番号",
          "representative_postal_code": "郵便番号",
          "representative_prefecture": "都道府県",
          "representative_town": "町域・番地",
          "representative_year": "年",
          "reset_password_sent_at": "パスワードリセット送信時刻",
          "reset_password_token": "パスワードリセット用トークン",
          "sign_in_count": "ログイン回数",
          "unconfirmed_email": "未確認Eメール",
          "unlock_token": "ロック解除用トークン",
          "updated_at": "更新日"
        }
      },
      "errors": {
        "models": {
          "review": {
            "attributes": {
              "publication_status": {
                "inclusion": "は true か false を入力してください"
              }
            }
          },
          "user": {
            "attributes": {
              "password": {
                "complexity": "は8文字以上64文字以下で、小文字、数字をそれぞれ1文字以上含む必要があります。"
              }
            }
          }
        }
      },
      "models": {
        "user": "ユーザー"
      }
    },
    "address": {
      "formats": {
        "postal_code": "〒%{postal_code}"
      }
    },
    "admin": {
      "blacklist_words": {
        "create": {
          "success": "不適切ワード「%{word}」を追加しました"
        },
        "destroy": {
          "success": "不適切ワード「%{word}」を削除しました"
        }
      },
      "check_in_calendars": {
        "update": {
          "alert": "ステータスを OK にする場合は必ずシーズンを選択してください"
        }
      },
      "imported_reviews": {
        "destroy": {
          "success": "レビューを削除しました"
        },
        "photos": {
          "destroy": {
            "success": "レビュー画像を削除しました"
          }
        },
        "update": {
          "success": "レビューを更新しました"
        }
      },
      "reviews": {
        "publication": "レビューを公開しました",
        "unpublication": "レビューを非公開にしました"
      }
    },
    "common": {
      "foot_consultation": {
        "button": "留学の相談をする",
        "lead_1": "留学先選びや留学に関するお悩みは、",
        "lead_2": "保育園留学プランナーにご相談ください。",
        "notes": "ご家族のご予定やご希望に合わせた留学先選び、留学に関するお悩み相談など、「保育園留学プランナー」がサポートいたします。チャットやオンライン対話（zoom）でお気軽にご相談ください。",
        "url": "https://hoikuen-ryugaku.com/planner"
      },
      "footer": {
        "consult": {
          "link": "プランナーに相談をする",
          "notes": "ご家族さまのご希望に合わせてプランナーがご対応いたします。",
          "title": "アレルギー対応や特別支援が必要なご家族へ",
          "url": "https://hoikuen-ryugaku.com/planner"
        },
        "fee": {
          "link": "表示料金に含まれるもの",
          "notes": "表示されている料金については以下からご確認ください。",
          "title": "表示料金について",
          "url": "https://hoikuen-ryugaku.com/plan"
        },
        "landing_page": {
          "about": "保育園留学とは",
          "company_info": "会社情報",
          "conditions": "取引条件書",
          "contact_about_banner": "留学プランナーに相談",
          "contact_modal": {
            "after_booking": "ご予約後",
            "before_booking": "ご予約前",
            "go_to_line": "LINEへ遷移します",
            "go_to_mail": "メールへ遷移します",
            "title": "ご予約状況によりお問い合わせ方法が変わります"
          },
          "contact_via_line": "LINEで留学先診断",
          "elementary_school": "小学生留学",
          "faq": "よくある質問",
          "inquiries": "お問い合わせ",
          "invite_friend": "お友だち紹介プログラム",
          "kitchhike_company": "株式会社 キッチハイク",
          "mypage_button": "留学ご家族専用 マイページ",
          "operation_company": "運営会社",
          "plan_contact": "留学先に迷ったら",
          "plan_hint": "留学先選びのヒント集",
          "plan_list": "留学先一覧",
          "price_plan": "料金プラン",
          "privacy_policy": "プライバシーポリシー",
          "recruit": "採用情報",
          "related_service": "関連サービス",
          "responsibility": "地域・自治体の皆様へ",
          "search_plan": "留学先を探す",
          "stipulation": "旅行業約款",
          "study_abroad_experience": "留学体験談",
          "study_abroad_tax": "留学先納税",
          "terms_of_use": "サービス利用規約",
          "title": "保育園留学",
          "travel_deal_details": "旅行取引の詳細",
          "your_nursery": "おとなの保育園留学"
        },
        "request": {
          "link_1": "留学ご家族へのお願い",
          "link_2": "キャンセルポリシー",
          "notes": "保育園留学は、保育園と宿と地域の人の協力のもと成り立っている事業です。留学時に守ってほしいお願いを記載したので、ご一読ください。",
          "title": "予約前にご確認ください",
          "url_1": "https://hoikuen-ryugaku.com/plan#request"
        },
        "sitemap": {
          "link_text_1": "運営会社",
          "link_text_2": "お問い合わせ",
          "link_text_3": "旅行取引の詳細",
          "link_text_4": "旅行業約款",
          "link_text_5": "取引条件書",
          "url_1": "https://kitchhike.jp/",
          "url_2": "mailto:support@hoikuen-ryugaku.zendesk.com",
          "url_3": "https://hoikuen-ryugaku.com/travel-deal-details",
          "url_4": "https://hoikuen-ryugaku.com/stipulation",
          "url_5": "https://hoikuen-ryugaku.com/jokensho"
        }
      },
      "google_tag_manager": {
        "id": "GTM-KMLC3MB"
      },
      "header": {
        "back_path_text": "サービスサイトへ戻る",
        "logo": "/images/logo_image_ja.png",
        "menu": {
          "mypage": "マイページ",
          "mypage_top": "マイページTOP",
          "service_top": "サービスTOP"
        },
        "title": "予約サイト",
        "url": "https://hoikuen-ryugaku.com/"
      },
      "message_bar": {
        "holiday": "ーーーー年末年始休業のお知らせーーーー\n休業期間：2024年12月28日（土）～2025年1月5日（日）\n※予約リクエスト結果につきましては、年明けの1月6日より順次確認しご連絡させていただきます。\nご迷惑をおかけいたしますが、何卒ご理解とご協力を賜りますようお願い申し上げます。\n",
        "maintenance": "現在システムメンテナンス中のため、動作が不安定になる可能性があります。操作がうまくいかない場合は時間を空けて再度お試し下さい。"
      }
    },
    "date": {
      "abbr_day_names": [
        "日",
        "月",
        "火",
        "水",
        "木",
        "金",
        "土"
      ],
      "formats": {
        "date_full_with_weekday": "%Y年%m月%d日 (%a)",
        "month_and_day_simple": "%m/%d",
        "month_and_day_with_weekday": "%-m/%-d(%a)",
        "year_and_month_and_day": "%Y/%-m/%-d"
      },
      "order": [
        "year",
        "month",
        "day"
      ]
    },
    "day": {
      "formats": {
        "short": {
          "friday": "金",
          "monday": "月",
          "saturday": "土",
          "sunday": "日",
          "thursday": "木",
          "tuesday": "火",
          "wednesday": "水"
        }
      }
    },
    "devise": {
      "confirmations": {
        "account_verified": "アカウントが確認されました。",
        "already_confirmed": "このメールアドレスは既に認証済みです。",
        "confirmation_sent": "確認用のメールを送信しました。",
        "confirmed": "メールアドレスが確認できました。",
        "failed": "メールアドレスの確認に失敗しました。確認リンクが無効か、既に確認済みの可能性があります。",
        "new": {
          "resend_confirmation_instructions": "アカウント確認メール再送"
        },
        "send_instructions": "アカウントの有効化について数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、本人確認用のメールが数分以内に送信されます。"
      },
      "failure": {
        "already_authenticated": "すでにログインしています。",
        "inactive": "アカウントが有効化されていません。メールに記載された手順にしたがって、アカウントを有効化してください。",
        "invalid": "%{authentication_keys}またはパスワードが違います。",
        "last_attempt": "もう一回誤るとアカウントがロックされます。",
        "locked": "アカウントはロックされています。",
        "not_found_in_database": "%{authentication_keys}またはパスワードが違います。",
        "timeout": "セッションがタイムアウトしました。もう一度ログインしてください。",
        "unauthenticated": "ログインもしくはアカウント登録してください。",
        "unconfirmed": "メールアドレスの本人確認が必要です。"
      },
      "mailer": {
        "confirmation_instructions": {
          "action": "メールアドレスの確認",
          "greeting": "%{recipient}様",
          "instruction": "以下のリンクをクリックし、メールアドレスの確認手続を完了させてください。",
          "subject": "メールアドレス確認メール"
        },
        "email_changed": {
          "greeting": "こんにちは、%{recipient}様。",
          "message": "メールアドレスの（%{email}）変更が完了したため、メールを送信しています。",
          "message_unconfirmed": "メールアドレスが（%{email}）変更されたため、メールを送信しています。",
          "subject": "メール変更完了"
        },
        "password_change": {
          "greeting": "%{recipient}様",
          "message": "パスワードが再設定されました。",
          "subject": "パスワードの変更について"
        },
        "reset_password_instructions": {
          "action": "パスワード変更",
          "greeting": "%{recipient}様",
          "instruction": "パスワード再設定の依頼を受けたため、メールを送信しています。下のリンクからパスワードの再設定ができます。",
          "instruction_2": "パスワード再設定の依頼をしていない場合、このメールを無視してください。",
          "instruction_3": "パスワードの再設定は、上のリンクから新しいパスワードを登録するまで完了しません。",
          "subject": "パスワードの再設定について"
        },
        "unlock_instructions": {
          "action": "アカウントのロック解除",
          "greeting": "%{recipient}様",
          "instruction": "アカウントのロックを解除するには下のリンクをクリックしてください。",
          "message": "ログイン失敗が繰り返されたため、アカウントはロックされています。",
          "subject": "アカウントのロック解除について"
        }
      },
      "omniauth_callbacks": {
        "failure": "%{kind} アカウントによる認証に失敗しました。理由：（%{reason}）",
        "success": "%{kind} アカウントによる認証に成功しました。"
      },
      "passwords": {
        "edit": {
          "change_my_password": "パスワードを変更する",
          "change_your_password": "パスワードを変更",
          "confirm_new_password": "確認用新しいパスワード",
          "new_password": "新しいパスワード"
        },
        "new": {
          "forgot_your_password": "パスワードを忘れましたか？",
          "send_me_reset_password_instructions": "パスワードの再設定方法を送信する"
        },
        "no_token": "このページにはアクセスできません。パスワード再設定メールのリンクからアクセスされた場合には、URL をご確認ください。",
        "send_instructions": "パスワードの再設定について数分以内にメールでご連絡いたします。",
        "send_paranoid_instructions": "メールアドレスが登録済みの場合、パスワード再設定用のメールが数分以内に送信されます。",
        "updated": "パスワードが正しく変更されました。",
        "updated_not_active": "パスワードが正しく変更されました。"
      },
      "registrations": {
        "destroyed": "アカウントを削除しました。またのご利用をお待ちしております。",
        "edit": {
          "are_you_sure": "本当によろしいですか？",
          "cancel_my_account": "アカウント削除",
          "currently_waiting_confirmation_for_email": "%{email} の確認待ち",
          "leave_blank_if_you_don_t_want_to_change_it": "空欄のままなら変更しません",
          "title": "%{resource}編集",
          "unhappy": "気に入りません",
          "update": "更新",
          "we_need_your_current_password_to_confirm_your_changes": "変更を反映するには現在のパスワードを入力してください"
        },
        "invalid_credentials": "無効なメールアドレスまたはパスワードです。",
        "new": {
          "sign_up": "アカウント登録"
        },
        "signed_up": "アカウント登録が完了しました。",
        "signed_up_but_inactive": "ログインするためには、アカウントを有効化してください。",
        "signed_up_but_locked": "アカウントがロックされているためログインできません。",
        "signed_up_but_unconfirmed": "本人確認用のメールを送信しました。メール内のリンクからアカウントを有効化させてください。",
        "update_needs_confirmation": "プロフィールを更新しました。変更されたメールアドレスの本人確認のため、本人確認用メールより確認処理をおこなってください。",
        "updated": "アカウント情報を変更しました。",
        "updated_but_not_signed_in": "あなたのアカウントは正常に更新されましたが、パスワードが変更されたため、再度ログインしてください。"
      },
      "sessions": {
        "already_signed_out": "既にログアウト済みです。",
        "new": {
          "sign_in": "ログイン"
        },
        "signed_in": "ログインしました。",
        "signed_out": "ログアウトしました。"
      },
      "shared": {
        "links": {
          "back": "戻る",
          "didn_t_receive_confirmation_instructions": "アカウント確認のメールを受け取っていませんか？",
          "didn_t_receive_unlock_instructions": "アカウントのロック解除方法のメールを受け取っていませんか？",
          "forgot_your_password": "パスワードを忘れましたか？",
          "sign_in": "ログイン",
          "sign_in_with_provider": "%{provider}でログイン",
          "sign_up": "アカウント登録"
        },
        "minimum_password_length": "（%{count}字以上）"
      },
      "unlocks": {
        "new": {
          "resend_unlock_instructions": "アカウントのロック解除方法を再送する"
        },
        "send_instructions": "アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "send_paranoid_instructions": "アカウントが見つかった場合、アカウントのロック解除方法を数分以内にメールでご連絡します。",
        "unlocked": "アカウントをロック解除しました。"
      }
    },
    "discount_code_mailer": {
      "discount_code_email": {
        "subject": "紹介コード発行完了のお知らせ 【保育園留学 運営事務局】"
      }
    },
    "enumerize": {
      "kintone/family_master": {
        "allergenic_foods": {
          "egg": "卵",
          "fruit": "果物",
          "meat_fish": "肉・魚",
          "milk": "牛乳・乳製品",
          "others": "その他",
          "shellfish": "甲殻類",
          "soy": "豆・穀・種実類",
          "wheat": "小麦"
        },
        "allergy_elimination": {
          "no_answer": "いいえ",
          "yes_answer": "はい"
        },
        "appetite_food": {
          "high": "旺盛",
          "low": "あまりない",
          "normal": "ふつう"
        },
        "baby_food": {
          "before_start": "開始前",
          "complete": "完了期",
          "early": "初期",
          "late": "後期",
          "middle": "中期",
          "toddler": "幼児食"
        },
        "breastfeeding": {
          "breast_milk": "母乳",
          "formula": "粉ミルク",
          "mixed": "混合",
          "weaned": "卒乳済み"
        },
        "business": {
          "company_employee_1": "会社員（総合職）",
          "company_employee_2": "会社員（一般職）",
          "contract_employee": "契約社員・派遣社員",
          "housewife": "専業主婦・主夫",
          "manager": "経営者・役員",
          "medical_personnel": "医療関係者",
          "other": "その他",
          "part_timer": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employed": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "unemployed": "無職"
        },
        "developmentaldisorder": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "exercise": {
          "crawling": "ハイハイ",
          "rolling_over": "寝返り",
          "standing_with_support": "つかまり立ち",
          "walking": "歩く"
        },
        "family_relationship": {
          "brother": "兄弟/姉妹",
          "father": "父親",
          "grandfather": "祖父",
          "grandmother": "祖母",
          "member": "本人",
          "mother": "母親",
          "other": "その他"
        },
        "food_allergies_yes_or_no": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "foodrequest_yes_or_no": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "gender": {
          "female": "女",
          "male": "男",
          "other": "その他"
        },
        "medical_history": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "napping": {
          "alone": "ひとりで",
          "carried": "おんぶ",
          "cuddle": "添い寝",
          "held": "だっこ"
        },
        "nonfood_allergies": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "opportunitynurseryschool": {
          "no_answer": "無",
          "yes_answer": "有"
        },
        "planned_participation": {
          "daycare": "保育園留学",
          "elementary": "小学生留学"
        },
        "question1": {
          "answer": "確認しました"
        },
        "same_as_representative_address": {
          "same_as_representative_address": "代表者と同じ"
        },
        "same_as_representative_phone_number": {
          "same_as_representative_phone_number": "代表者と同じ"
        },
        "school_type": {
          "national": "国立",
          "private": "私立",
          "public": "公立"
        },
        "toilet": {
          "fail": "トイレでできない",
          "success": "トイレでできる",
          "training": "練習中"
        },
        "underwear": {
          "cloth_diaper": "布おむつ",
          "cloth_pants": "布パンツ",
          "disposable_diaper": "紙おむつ",
          "training_pants": "トレーニングパンツ"
        }
      },
      "kintone/representative_user_master": {
        "business": {
          "company_employee_1": "会社員（総合職）",
          "company_employee_2": "会社員（一般職）",
          "contract_employee": "契約社員・派遣社員",
          "housewife": "専業主婦・主夫",
          "manager": "経営者・役員",
          "medical_personnel": "医療関係者",
          "other": "その他",
          "part_timer": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employed": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "unemployed": "無職"
        },
        "co_workers": {
          "no_answer": "いいえ",
          "yes_answer": "はい"
        },
        "family_relationship": {
          "brother": "兄弟/姉妹",
          "father": "父親",
          "grandfather": "祖父",
          "grandmother": "祖母",
          "member": "本人",
          "mother": "母親",
          "other": "その他"
        },
        "gender": {
          "female": "女性",
          "male": "男性",
          "other": "その他"
        }
      },
      "kintone/reservation_request": {
        "interview": {
          "cooperation": "協力します",
          "no_cooperation": "協力しません"
        },
        "prtrait_right": {
          "limited_permission": "留学施設の関係者・保護者の個人利用のみ許可する（連絡帳など）",
          "no_permission": "写真の掲載を許可しません",
          "yes_permission": "写真の掲載を許可します"
        },
        "route": {
          "facebook": "Facebook",
          "family": "両親・家族からの紹介",
          "flyers": "チラシ",
          "friends": "友だち・同僚からの紹介",
          "instagram": "Instagram",
          "line": "LINE",
          "newspapers": "新聞",
          "other": "その他",
          "preschool": "通っている園からの紹介",
          "search": "検索",
          "tv": "テレビ",
          "web_news": "Webニュース・web記事",
          "x": "X",
          "youtube": "Youtube"
        }
      },
      "kintone/todo_master": {
        "requirement_status": {
          "conditionally_required": "条件付き必須",
          "required": "必須"
        },
        "ryugaku_type": {
          "all": "すべて",
          "domestic": "国内のみ",
          "jpe": "JPEのみ"
        },
        "time_limit_entry_point": {
          "end_of_stay": "滞在終了日",
          "end_of_stay_on_the_day": "滞在終了日実施",
          "interview_date": "面談日",
          "interview_date_on_the_day": "面談日実施",
          "reservation_accepted_date": "予約承認日",
          "reservation_accepted_date_on_the_day": "予約承認日実施",
          "start_of_stay": "滞在開始日",
          "start_of_stay_on_the_day": "滞在開始日実施"
        },
        "todo_type": {
          "common_todo": "全予約共通todo",
          "guest_house_todo": "宿に紐づくtodo",
          "nursery_todo": "留学施設に紐づくtodo"
        },
        "url_categories": {
          "family_form": "家族情報登録フォーム",
          "nursery_meeting_form": "面談日程調整",
          "reservation_form": "事前質問フォーム",
          "review_form": "留学後アンケートフォーム",
          "todo_uploads_form": "汎用フォームページ",
          "todos_form": "汎用情報ページ"
        }
      }
    },
    "error_page": {
      "back_path": "予約可能な留学先一覧へ戻る"
    },
    "errors": {
      "messages": {
        "already_confirmed": "は既に登録済みです。ログインしてください。",
        "blank": "を入力してください。",
        "confirmation": "とパスワードの入力が一致しません。",
        "confirmation_period_expired": "の期限が切れました。%{period} までに確認する必要があります。 新しくリクエストしてください。",
        "expired": "の有効期限が切れました。新しくリクエストしてください。",
        "invalid": "が正しくありません。",
        "not_found": "は見つかりませんでした。",
        "not_locked": "はロックされていません。",
        "not_saved": {
          "one": "エラーが発生したため %{resource} は保存されませんでした。",
          "other": "%{count} 件のエラーが発生したため %{resource} は保存されませんでした。"
        },
        "only_numbers_allowed": "は数字のみを入力してください",
        "password_invalid": "パスワードが正しくありません。",
        "too_short": "が短すぎます（最小 %{count} 文字）"
      }
    },
    "helpers": {
      "submit": {
        "complete": "完了にすすむ",
        "save": "保存する",
        "submit": "提出にすすむ"
      }
    },
    "landing_page": {
      "avaiability": {
        "room_master": {
          "access_way": "園との距離",
          "bathroom": "浴室",
          "check_floor_plan": "間取り図を確認する",
          "drawer_title": "宿の詳細",
          "environment": "特徴",
          "food": "食事",
          "max_capacity": "定員(合計%{count}人のみ)",
          "work_environment": "仕事環境"
        }
      }
    },
    "login": {
      "email": "メールアドレス",
      "password": "パスワード",
      "reset_password": "パスワードを忘れた方はこちら",
      "submit": "ログインする",
      "title": "ログイン"
    },
    "mailer": {
      "from": "保育園留学 運営事務局 <no-reply@kitchhike.com>"
    },
    "message": {
      "error": {
        "address": {
          "load": "住所の取得に失敗しました。手動で入力してください。"
        },
        "card": {
          "expiration_date": {
            "expired": "カードの有効期限が過ぎています。",
            "incorrect": "カードの有効期限に不備があります。"
          },
          "number": {
            "incorrect": "カード番号に不備があります。"
          },
          "security_code": {
            "incorrect": "カードのセキュリティコードに不備があります。"
          }
        },
        "code": {
          "e_000": "予期せぬエラーが発生しました。運営事務局へお問い合わせください。",
          "e_001": "開始日が無効であるか、チェックイン日がすでに予約されています。予約可能な日程であるか再度ご確認ください。",
          "e_002": "入力パラメータが正しくありません。選択した留学先やプラン、日程を再度ご確認ください。",
          "e_003": "ご入力いただいたメールアドレスですでにこの期間に予約されています。メールに送信された予約内容をご確認ください。",
          "e_004": "留学先が見つかりません。選択した留学先を再度ご確認ください。",
          "e_005": "プランが見つかりません。選択したプランを再度ご確認ください。",
          "e_006": "宿泊施設が見つかりません。選択したプラン、日程を再度ご確認ください。",
          "e_007": "宿泊施設が見つかりません。選択したプラン、日程を再度ご確認ください。",
          "e_008": "販売可能な日付の数が滞在日数と一致しません。選択したプラン、日程を再度ご確認ください。",
          "e_009": "お選びいただいた日程が満枠のようです。他の日程で再度ご予約いただくか、プランナーへお問い合わせください。<br><a href='https://hoikuen-ryugaku.com/planner'>https://hoikuen-ryugaku.com/planner</a>"
        },
        "email": {
          "load": "メールアドレスが登録可能か否かの取得に失敗しました。"
        },
        "error_001": "Error: data available_sale_date of next month is empty",
        "error_002": "Error: data available_sale_date is not equal with real stay_day",
        "error_003": "Error: One of the Available Sale Date records has a status other than 販売中.",
        "field": {
          "date": "日付"
        },
        "input": {
          "check": "%{field_name}にチェックを付けてください",
          "email_exists": "このメールアドレスはすでに登録されています。上部のリンクからログインしてください。",
          "enter": "%{field_name}を入力してください",
          "password_mismatch": "パスワードが一致しません。",
          "select": "%{field_name}を選択してください",
          "valid_enter": "有効な%{field_name}を入力してください"
        },
        "please_try_again": "時間をおいてもう一度お試しください",
        "promotion": {
          "already_used": "すでに利用済みのコードです。",
          "invalid_code": "このコードは無効です。",
          "invalid_period": "このコードは利用期間外です。",
          "invalid_plan": "このプランには対象外のコードです。",
          "own_code": "本人の紹介コードは利用できません。"
        }
      },
      "error_404": "404 ページが見つかりません",
      "error_422": "422 処理できないエンティティ",
      "error_500": "500 内部サーバーエラー"
    },
    "month": {
      "abbr_month_names": {
        "1": "1月",
        "10": "10月",
        "11": "11月",
        "12": "12月",
        "2": "2月",
        "3": "3月",
        "4": "4月",
        "5": "5月",
        "6": "6月",
        "7": "7月",
        "8": "8月",
        "9": "9月"
      }
    },
    "number": {
      "currency": {
        "format": {
          "delimiter": ",",
          "format": "%u %n",
          "precision": 0,
          "separator": ".",
          "significant": false,
          "strip_insignificant_zeros": false
        }
      }
    },
    "nursery_meeting_email": {
      "to_user": {
        "meeting_date_time": "%{meeting_date_time}",
        "nursery_name": "%{nursery_name}",
        "subject": "面談予約を承りました【保育園留学 運営事務局】",
        "text1": "面談予約を承りました。\nご登録ありがとうございます。",
        "text2": "※面談日より3日前以内のご予約の場合、先生方の保育業務の都合により面談日の調整の依頼をさせていただくことがございます。\n何卒ご了承ください。",
        "text3": "ご予約のお時間が近づいてまいりましたら、\nご家族マイページのやることリストの面談項目をご確認ください。",
        "text4": "やることリストを確認する",
        "text5": "予約の変更・キャンセルは基本的に承っておりませんが、\n万が一ご都合が悪くなった場合は、直接滞在先の園へキャンセルされる旨お伝えいただき、\n再予約につきましては、運営事務局へお問い合わせください。",
        "text6": "※本メールにお心当りのない場合は、お手数ですが下記メール宛に\n返信いただけますようお願い申し上げます。",
        "user_full_name": "%{last_name} %{first_name}さま",
        "user_name": "%{user_name} さま"
      }
    },
    "ogp": {
      "confirmation": {
        "new": {
          "title": "保育園留学 | 確認メール再送信"
        }
      },
      "error": {
        "show": {
          "title": "エラー"
        }
      },
      "landing_page": {
        "title": "保育園留学 | %{nursery_name}"
      },
      "mypage": {
        "index": {
          "title": "保育園留学 | マイページ"
        }
      },
      "plan": {
        "index": {
          "description": "保育園留学の留学先 %{alias} のプラン一覧を確認できます。",
          "title": "保育園留学 %{alias} プラン一覧 予約"
        },
        "show": {
          "description": "保育園留学の留学先 %{plan_name} のプラン内容を確認できます。",
          "title": "保育園留学 %{plan_name} 予約"
        }
      },
      "profile": {
        "show": {
          "title": "保育園留学 | プロフィール"
        }
      },
      "referral_code": {
        "complete": {
          "title": "保育園留学 | 紹介コード発行完了"
        },
        "new": {
          "title": "保育園留学 | 紹介コード発行の情報入力"
        }
      },
      "registration": {
        "edit": {
          "title": "保育園留学 | メールアドレス変更"
        }
      },
      "reservation": {
        "complete": {
          "title": "保育園留学 | 予約リクエスト完了"
        },
        "confirm": {
          "title": "保育園留学 | 予約内容確認"
        },
        "new": {
          "title": "保育園留学 | 予約情報入力"
        }
      },
      "reset_password": {
        "new": {
          "title": "保育園留学 | パスワード再設定"
        }
      },
      "reviews": {
        "index": {
          "description": "保育園留学の留学先 %{alias} に滞在したご家族の声を確認できます。",
          "title": "保育園留学 %{alias} ご家族の声一覧"
        }
      },
      "session": {
        "new": {
          "title": "保育園留学 | ログイン"
        }
      },
      "site_name": "保育園留学 | 留学先一覧 予約サイト",
      "top": {
        "index": {
          "description": "保育園留学の留学先の空き枠状況や料金を一覧で確認できます。",
          "image": "/images/nursery_OGP_image_ja.jpg",
          "title": "保育園留学 | 留学先一覧 予約"
        }
      }
    },
    "password": {
      "confirm_password": "パスワード（確認用）",
      "email": "メールアドレス",
      "notes_1": "入力されたメールアドレス宛にパスワード再設定のURLを送信します。",
      "password": "パスワード",
      "reset_button": "パスワードを設定する",
      "reset_email_submit": "送信する",
      "title": "パスワード再設定"
    },
    "plan_detail": {
      "access": {
        "address": "住所：〒%{postal_code}",
        "title": "アクセス"
      },
      "accommodation": {
        "title": "宿泊施設",
        "type": "宿タイプ：%{type}、 定員%{capacity}名"
      },
      "back_path": "一覧へ戻る",
      "carousel": {
        "more": "もっと写真を見る"
      },
      "check_in_out": {
        "check_in": "チェックイン",
        "check_out": "チェックアウト",
        "title": "チェックイン・チェックアウト"
      },
      "childcare": {
        "notes": "持ち物や服装を確認",
        "title": "保育時間",
        "weekdays": "平日：%{start_time}〜%{end_time}（%{hours}時間）"
      },
      "eligibility": "受入条件：%{eligibility}",
      "extended": {
        "title": "延長保育時間"
      },
      "facility": {
        "notes": "部屋ごとの設備を確認",
        "title": "設備・備品"
      },
      "label": {
        "aboard_accept_class": "年齢",
        "access": "アクセス",
        "address": "住所",
        "allergy": "アレルギー対応",
        "childcare_time": "時間",
        "elementary_accept_class": "学年",
        "entry_requirement": "登園経験のない子どもの受入",
        "extending_time": "延長保育",
        "google_map": "Google mapはこちら",
        "lunch": "給食"
      },
      "local": {
        "button": "留学先案内サイトを見る",
        "text": "保育施設の魅力や特徴、暮らし環境、ワークスペース、周辺マップや週末アクティビティなど、より詳細な現地情報はこちらの留学先案内サイトからご確認いただけます。",
        "title": "現地情報"
      },
      "navigation": {
        "accommodation": "宿泊施設",
        "available_plan": "留学プラン",
        "family_voice": "ご家族の声",
        "nursery_info": "留学施設"
      },
      "preschool": "保育施設",
      "remote_work": {
        "title": "リモートワーク環境"
      },
      "reservation": {
        "breakdown": "内訳",
        "button": "予約にすすむ",
        "date_range": {
          "select": "日付をえらぶ"
        },
        "modal": {
          "breakdown": {
            "adult_rate": "大人料金（税込）※中学生以上",
            "basic_price": "基本料金",
            "child_rate": "子ども料金（1泊）",
            "elementary_aboard": "小学生留学：￥%{unit_price} ×",
            "not_and_elementary": "留学なし（小学生）：￥%{unit_price} ×",
            "not_and_toddler": "留学なし（未就学児）：￥%{unit_price} ×",
            "nursery_aboard": "保育園留学：￥%{unit_price} ×",
            "option_price": "オプション料金（税込）",
            "plan_price": "プラン料金（税込）",
            "title": "料金の内訳",
            "total": "料金合計（税込）"
          },
          "clear": "クリア",
          "close": "閉じる",
          "people": {
            "adult": "大人",
            "child": "子ども",
            "elementary_aboard": "小学生留学",
            "not_and_elementary": "留学なし（小学生）",
            "not_and_toddler": "留学なし（未就学児）",
            "notes_1": "留学開始日での年齢をもとに入力ください。プランにより受け入れ対象外の場合があります。",
            "notes_3": "数日のみ同伴する家族（大人）がいる場合は、次の画面の「オプション選択」で人数と宿泊日数をご入力ください。",
            "nursery_aboard": "保育園留学",
            "nursery_elementary_aboard": "保育園留学・小学生留学",
            "title": "人数"
          },
          "save": "保存"
        },
        "people": {
          "select": ""
        },
        "sold_out": "売り切れ",
        "total": "料金合計"
      },
      "reviews": {
        "read_more": "続きを読む",
        "read_others": "%{count}件をすべて表示"
      },
      "room_info": {
        "accommodation_info": "滞在先情報",
        "accommodation_type": "宿タイプ",
        "address": "住所",
        "bathroom": "バスルーム",
        "bedroom": "寝室",
        "capacity": {
          "number": "最大%{count}名",
          "title": "定員"
        },
        "kitchen": "キッチン",
        "laundry": "ランドリー",
        "meal_service": "食事サービス",
        "pets": "ペット",
        "separate_room": "夫婦別室ワーク",
        "transportation": "移動手段",
        "wifi": "Wi-Fi"
      },
      "same_region_plan": "この地域の他のプラン",
      "section": {
        "accommodation": "宿泊施設",
        "accommodation_access_aboard": "アクセス(宿泊施設↔︎保育施設)",
        "accommodation_access_nursery": "アクセス(宿泊施設↔︎留学施設)",
        "accommodation_info": "滞在先情報",
        "available_plan": "留学プラン",
        "educational_facility": "保育施設",
        "family_voice": "ご家族の声",
        "preschool_facility": "留学施設"
      },
      "view_detail": "留学先サイトを見る"
    },
    "plan_list": {
      "back_path": "留学先一覧へ戻る",
      "component": {
        "accept_class": "留学できるクラス",
        "button": {
          "available_date": "空き日程",
          "select": "プラン選択",
          "sold_out": "売り切れ"
        },
        "capacity": {
          "all": "定員%{count}名",
          "one": "Max. %{count} Person",
          "other": "Max. %{count} People"
        },
        "currency": "￥",
        "estimate": "大人2名・子ども1名の目安",
        "inquire_whatapp": "WhatsAppへの導線する",
        "loading": "ロード中...",
        "lp_check_availability": "空き日程を見る",
        "lp_see_more": "この留学先をもっと見る",
        "see_more": "もっと見る",
        "slot": {
          "full": "満枠",
          "left": "あと%{count}枠"
        },
        "time": "時間",
        "year_section": "%{year}年"
      },
      "empty": {
        "text_1": "現在、この留学先が募集しているプランはありません。",
        "text_2": "他の留学先からお探しください。"
      },
      "filtering": {
        "content": {
          "count": "しぼりこみ結果：%{count}/%{total}件",
          "count_result": "しぼりこみ結果：%{count}件",
          "title": "募集プラン一覧"
        },
        "period": {
          "form": "期間を選択",
          "title": "年月で絞り込み"
        },
        "title": "しぼりこみ"
      }
    },
    "price_text": "￥%{price}",
    "referral_code": {
      "cannot_be_used_for_the_referrers_own": "紹介コードは紹介者さまご自身の予約にはご利用いただけません。",
      "cannot_be_used_in_conjunction": "紹介コードは他のプロモーションコードと併用してご利用いただけません。",
      "click_the_button": "ご紹介者のお名前とメールアドレスを入力し、紹介コードを発行するボタンを押してください。",
      "complete": {
        "title": "保育園留学 | 紹介コード発行完了"
      },
      "copied_text": "紹介コード【%{code_value}】\n\n割引金額：%{amount_value}円\n\n※ご利用は１人１回まで\n\n「保育園留学」は、地域と子育て家族をつなぎ、未来を作る留学プログラム。\nhttps://hoikuen-ryugaku.com/",
      "copy_completed": "コピーが完了しました",
      "copy_the_referral_code": "紹介コードをコピーする",
      "email_address": "メールアドレス",
      "errors": {
        "not_valid": "ご登録情報と一致しません。内容を確認のうえ、再度お試しください。"
      },
      "first_name": "名（漢字）",
      "information_entry": "紹介者情報の入力",
      "issuance_of_referral_code": "紹介コードの発行",
      "issue_the_referral_code": "紹介コードを発行する",
      "last_name": "姓（漢字）",
      "new": {
        "title": "保育園留学 | 紹介コード発行の情報入力"
      },
      "no_expiration_date": "紹介コードのご利用に有効期限はありません。",
      "please_check_it": "あなたの紹介コードを発行いたしました。ご入力メールアドレス宛に、紹介コードのお控えメールをお送りしたので合わせてご確認ください。",
      "settings_to_allow_receipt_html": "<span>携帯メールアドレスを入力する場合は、届かない場合がありますので、</span><span class='underline'>no-reply@kitchhike.com</span><span>の指定受信設定をお願いいたします。</span>",
      "the_same_code_will_be_displayed": "紹介コードの発行は1人1つまでとなります。発行のお手続きを2度行っても同じコードが表示されますのでご了承ください。",
      "usage_guidelines": "ご利用の注意事項",
      "use_the_referral_code_only_once": "紹介された側が紹介コードを利用できるのは、1人1回までです。",
      "you_can_share": "紹介コードは何人にでもお配り貼りいただけます。",
      "your_referral_code": "あなたの紹介コード"
    },
    "registration": {
      "edit": {
        "email": "代表者メールアドレス",
        "password": "パスワード",
        "submit": "変更する",
        "title": "メールアドレス変更"
      }
    },
    "reservation": {
      "children_info": {
        "count": "%{count}人目",
        "title": "留学する子ども情報"
      },
      "heart_modal": {
        "check_text": "上記、「留学家族のこころえ」の内容に同意する",
        "mission": "私たちのミッションとして、「子育て世代がより人生を謳歌でき、素晴らしい地域が持続していく未来をつくる」を掲げております。この事業を持続可能なものとするために、ご家族には、いくつかの心得を身につけていただき、地域滞在をお楽しみいただくようお願いしています。",
        "rule_1": "「地域にお邪魔する」気持ちで滞在し、お礼を言葉や行動で表します。",
        "rule_2": "各留学先の方針を理解し、尊重します。",
        "rule_3": "マナーの良い行動を心がけ、送り迎えの時間を守ります。",
        "rule_4": "こどもの成長を第一に考えた行動を、心がけます。",
        "rule_5": "宿の利用ルールを守ります。",
        "rule_6": "地域の方針に沿って、暮らしのルールを守ります。",
        "sub_subscription": "保育園留学・小学生留学",
        "sub_title": "留学家族のこころえ",
        "submit": "予約内容の入力へ進む",
        "subscription": "お申し込みいただく前に、以下のご確認をお願いしています。",
        "text_1": "保育園留学・小学生留学は、“観光”ではなく“地域の暮らし”体験をお届けしています。地域コミュニティの一員として、気持ちのよい振る舞いをお願いしています。",
        "text_2": "保育園留学・小学生留学では、留学先の施設で日々行われている活動をそのまま体験していただきます。ご家庭の考え方と違う場合でも、異なる価値観を親子で考える機会と捉えることをお願いしています。",
        "text_3": "留学先によっては延長対応がある場合もありますが、決められた時間内での送り迎えを厳守してください。過度な要望がある場合、受け入れをお断りすることもありますのでご了承ください。",
        "text_4": "保育園留学・小学生留学の目的は、お子さまが地域の中で健やかに成長し、豊かな経験を積むことにあります。留学先や宿泊施設、自治体の方、まち全体が、「こどものため・地域のため」としてご家族を歓迎しております。リフレッシュを主目的とする場合には、他サービスのご利用をご検討ください。",
        "text_5": "宿泊施設にはホテルや旅館だけでなく、自治体が運営する移住体験施設もあります。過度なサービスを求めず、各施設の利用時間やルールを尊重し、地域で受け入れてくれる方へ迷惑をかけないようお願いしています。",
        "text_6": "ごみの分別や交通ルールを遵守し、地域の暮らしに配慮した行動を心がけてください。地域の施設やサービスを利用する際は、時間やルールを守り、気持ちよくご利用いただけるようご協力をお願いしています。",
        "title": "予約条件の確認"
      },
      "progress": {
        "complete": "完了",
        "confirm": "確認",
        "enter": "入力"
      },
      "representative": {
        "occupation": {
          "company_employee": "会社員（総合職）",
          "company_employee_support": "会社員（一般職）",
          "contract_temporary": "契約社員・派遣社員",
          "default": "職業を選択",
          "employer": "勤務先（任意）",
          "house": "専業主婦・主夫",
          "income": "共働きかどうか",
          "item": "職業",
          "manager": "経営者・役員",
          "medical": "医療関係者",
          "no_answer": "いいえ",
          "other": "その他",
          "part_time": "パート・アルバイト",
          "professional": "士業（公認会計士・弁護士・税理士・司法書士）",
          "public_employee": "公務員（教職員除く）",
          "retired": "定年退職",
          "self_employ": "自営業・自由業",
          "student": "学生",
          "teacher": "教職員",
          "title": "仕事",
          "unemploy": "無職",
          "yes_answer": "はい"
        }
      },
      "summary": {
        "accommodation": "宿泊施設：%{accommodation}",
        "adult": "大人%{count}人",
        "button": "プラン内容を見る",
        "child": "子ども%{count}人",
        "people": "人数：",
        "period": "留学期間：%{start_date}〜%{end_date}",
        "preschool": "留学施設：%{preschool}"
      }
    },
    "reservation_complete": {
      "back_path": "予約可能な留学先一覧へ戻る",
      "heading": "予約リクエスト完了",
      "notes_1": "ご予約をお受けできないこともございます。あらかじめご了承ください。",
      "notes_10": "お客様のアカウントが作成されました。",
      "notes_11": "アカウント認証のメールをお送りしていますので、",
      "notes_12": "ご確認ください。",
      "notes_2": "移動手段の確保やその他の手続きは、必ず予約確定後に行ってください。",
      "notes_3": "この後、運営側にて保育園と宿泊施設の受け入れ最終確認をいたします。最終確認が取れ次第、予約が確定となります。",
      "notes_4": "ご登録のメールアドレス宛に予約後のご案内をお送りしますので、お待ちください。（3営業日以内にご連絡いたします。）",
      "notes_5": "移動手段の確保やその他の手続きは、必ず予約確定後に行ってください。",
      "notes_6": "飛行機/新幹線",
      "notes_7": "レンタカー",
      "notes_8": "キャンセル保険の加入",
      "notes_9": "留学先納税　など",
      "title": "まだ予約は確定していません。"
    },
    "reservation_confirm": {
      "3dsecure": {
        "button": "3Dセキュアについて",
        "modal": {
          "body": "セキュリティの強化に伴い、ご利用のクレジットカードで3Dセキュア認証が必須となりました。\n予約リクエスト時に3Dセキュア認証が行われ、正常にご利用可能なカードかを確認させて頂きます。\n\nまた、3Dセキュア実施に伴い、3Dセキュア認証画面にて取引金額が「0円」と表示される事がございますが、認証や決済処理は正常に処理されております。\n\n引き続き安心してサービスをご利用いただくため、ご確認をお願いいたします。",
          "title": "3Dセキュア対応について"
        }
      },
      "account": {
        "password": "パスワード",
        "title": "アカウント情報"
      },
      "cancellation_caution": {
        "notes_1": "予約後7日間は、無料でキャンセルできます。",
        "notes_2": "はこちら。",
        "title": "予約後7日間は、キャンセル無料"
      },
      "caution": {
        "notes": "運営側がリクエストを承認するまで予約は確定されません。それまで請求は発生しません。",
        "title": "予約リクエストについて"
      },
      "heading": "予約内容の入力",
      "information": {
        "agree": {
          "check_box": "",
          "notes": ""
        },
        "cancellation": {
          "cancellation_policy_text": "キャンセルポリシー",
          "notes_1": "予約リクエスト送信後にキャンセル・日程変更する場合は、日数に応じてキャンセル料金が発生します。詳しくは",
          "notes_2": "をご確認ください。",
          "title": "【キャンセルについて】"
        },
        "confirmation": {
          "notes": "予約リクエスト送信時点では予約確定ではありません。登園されるお子さまの年齢や受け入れ先の状況を確認後、予約確定のご連絡をメールにてお送りさせていただきます。受け入れ先の状況によってご案内できない場合がございますので予めご了承ください。",
          "title": "【予約の確定】"
        },
        "other_item": {
          "cancel_text": "キャンセルポリシー",
          "conditions_text": "取引条件書",
          "conditions_url": "https://hoikuen-ryugaku.com/stipulation",
          "family_text": "ご家族向けの基本ルール",
          "family_url": "https://hoikuen-ryugaku.com/family-rules",
          "privacy_policy_text": "プライバシーポリシー",
          "privacy_policy_url": "https://hoikuen-ryugaku.com/privacy-policy",
          "terms_text": "サービス利用規約",
          "terms_url": "https://hoikuen-ryugaku.com/terms-of-use",
          "title": "予約に伴う確認事項"
        },
        "request_to_family": {
          "notes_1": "地域コミュニティの一員となるご家族のみなさまには、",
          "notes_2": "ご家族向けの基本ルール",
          "notes_3": "に従っていただくようお願いしています。",
          "title": "ご家族へのお願い",
          "url": "https://hoikuen-ryugaku.com/family-rules"
        },
        "title": "ご注意・ご案内"
      },
      "modal_booking": {
        "booking_info": "予約内容",
        "button": "予約リクエストにすすむ",
        "currency": "円",
        "currency_man": "万",
        "holiday_caption": "祝日は休園日です",
        "people": "名",
        "period": "留学期間：",
        "title": {
          "text_1": "以下の内容で",
          "text_2": "予約リクエストへ進みますか？"
        }
      },
      "payment": {
        "card_number": "クレジットカード番号",
        "expiration_date": "有効期限",
        "security_code": "セキュリティコード",
        "title": "お支払い方法"
      },
      "price": {
        "breakdown": "内訳",
        "breakdown_button": "料金の内訳を見る",
        "button": "予約をリクエストする",
        "confirmation": "私は、旅行条件書、プライバシーポリシー、サービス利用規約、キャンセルポリシー、ご家族向けの基本ルールを読んだ上で、内容に同意したものとします。また、予約リクエストを運営側で承認した場合、表示の金額の合計額を支払うことにも同意したものとします。",
        "processing": "リクエスト中...",
        "total": "料金合計（税込）"
      },
      "promotion": {
        "amount": "-￥%{amount}",
        "applied": "%{code}が適用されました。",
        "button": "適用する",
        "code": "紹介コード / プロモコード（任意）",
        "discount": "プロモーション割引：",
        "title": "プロモーション"
      },
      "representative": {
        "address": {
          "country": "国名",
          "email": "メールアドレス",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "title": "住所"
        },
        "date_of_birth": "生年月日",
        "gender": "性別",
        "name": "姓名（ふりがな）",
        "name_cn": "姓名",
        "relationship": "留学する子どもとの続柄",
        "relationship_other_text": "その他（任意）",
        "title": "代表者情報"
      }
    },
    "reservation_email": {
      "letter_block_1": {
        "text_1": "このメールアドレスは配信専用となっております。",
        "text_2": "お問い合わせはこちら▼",
        "text_3": "support@hoikuen-ryugaku.zendesk.com",
        "text_4": "この度は、保育園留学にお申し込みいただき誠にありがとうございます。",
        "text_5": "予約リクエストを受け付けました。",
        "text_6": "※現時点では予約が確定しておりません。",
        "text_7": "予約の確定は、【予約確定】のメールにてご連絡させていただきます。",
        "text_8": "登園されるお子さまの年齢や受け入れ先の状況により、",
        "text_9": "ご案内できない場合がございますので予めご了承ください。"
      },
      "letter_block_2": {
        "text_1": "【予約リクエスト内容】",
        "text_2": "プラン名：%{plan_name}",
        "text_3": "滞在開始日：%{start_date}",
        "text_4": "滞在終了日：%{end_date}",
        "text_5": "代表者名：%{representative_name}",
        "text_6": "合計金額：￥%{total_fee}"
      },
      "letter_block_3": {
        "text_1": "これより、予約内容を受け入れ先宿泊施設と園に確認し、最終調整をさせていただきます。",
        "text_10": "※アカウント登録の本人確認が完了されていない方は、別途お送りしているメールで本人確認を完了してください。",
        "text_11": "ログインURL. %{login_url}",
        "text_12": "【キャンセル・変更について】",
        "text_13": "ご予約後にお客様のご都合によりキャンセルする場合には、キャンセル料を申し受けます。",
        "text_14": "詳しくはキャンセルポリシーをご確認ください。",
        "text_15": "保育園留学が、お子様やご家族皆様にとって素敵な体験になることを心より願っております。",
        "text_2": "予約の可否につきましては、5営業日前後でご登録のメールアドレスへご連絡いたします。",
        "text_3": "恐れ入りますが今しばらくお待ちください。",
        "text_4": "※園の先生方の負担を減らし保育に時間をかけられるよう、",
        "text_5": "まとめて確認いただいておりますので、結果のお知らせが5営業日を超える場合がありますが",
        "text_6": "何卒ご了承ください。",
        "text_7": "【マイページについて】",
        "text_8": "お客様のアカウントにログインしていただくと、マイページから予約内容をご確認いただけます。",
        "text_9": "予約リクエストが承認されましたら、マイページのやることリストから必要な手続きをご確認いただけます。"
      },
      "letter_block_4": {
        "text_1": "保育園留学 運営事務局",
        "text_2": "HP. https://hoikuen-ryugaku.com/",
        "text_3": "mail. support@hoikuen-ryugaku.zendesk.com",
        "text_4": "※返信には3-4営業日いただく場合がございます（土日祝除く）",
        "text_5": "運営会社：株式会社キッチハイク",
        "text_6": "東京都台東区東上野4-13-9 ROUTE 89 BLDG. 4F",
        "text_7": "https://kitchhike.com",
        "text_8": "一緒に働く仲間を募集しています",
        "text_9": "https://kitchhike.jp/recruit"
      }
    },
    "reservation_input": {
      "accordion": {
        "icon_message": "未入力の項目があります",
        "message_no_selected": "選択なし",
        "message_not_input": "未入力"
      },
      "children_info": {
        "allergy": {
          "allergenic_foods": {
            "beans_grains_nuts": "豆・穀・種実類",
            "default": null,
            "egg": "卵",
            "fruits": "果物",
            "meat_fish": "肉・魚",
            "milk": "牛乳・乳製品",
            "other": "その他",
            "shellfish": "甲殻類",
            "title": "アレルギーの原因となる食品",
            "validation_title": "アレルギーの原因となる食品",
            "wheat": "小麦"
          },
          "allergy_causes": {
            "default": null,
            "title": "アレルギーの原因となるもの",
            "validation_title": "アレルギーの原因となるもの"
          },
          "allergy_elimination": {
            "default": "選択してください",
            "no_answer": "いいえ",
            "title": "留学先で除去食の対応を希望しますか",
            "validation_title": "留学先で除去食の対応",
            "yes_answer": "はい"
          },
          "availability": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "食物アレルギーはありますか",
            "validation_title": "食物アレルギーの有無",
            "yes_answer": "有"
          },
          "foodrequest": {
            "default": null,
            "title": "食事についてスペシャルリクエスト",
            "validation_title": "食事についてスペシャルリクエスト"
          },
          "foodrequest_yes_or_no": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮が必要ですか",
            "validation_title": "食事に関して、宗教上の理由、またはプラントベースの食生活(ベジタリアンなど)に関する特別な配慮の有無",
            "yes_answer": "有"
          },
          "nonfood_allergies": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "食物以外のアレルギーの有無",
            "validation_title": "食物以外のアレルギーの有無",
            "yes_answer": "有"
          },
          "other_food_name": {
            "default": null,
            "title": "その他の場合、食材を記入してください",
            "validation_title": "その他食材"
          },
          "question1": {
            "confirmation": "確認しました",
            "title": "除去食の対応・その他特別な対応が必要となる場合は、必ず面談時に先生へ直接相談し、各施設の必要な手続きを行ってください。なお、対応の可否や対応レベルは各施設によって異なりますので、予めご了承ください。",
            "validation_title": "チェックボックス"
          },
          "symptoms": {
            "default": null,
            "description": "アレルギーの程度や配慮が必要なこと、またアナフィラキシー症状、服薬がある場合もこちらに必ずご記入ください。",
            "title": "アレルギーの症状・詳細",
            "validation_title": "アレルギーの症状・詳細"
          },
          "title": "アレルギー情報"
        },
        "base": {
          "title": "基本情報"
        },
        "enrollment_school": {
          "school_name": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "在籍している学校名",
            "validation_title": "在籍している学校名",
            "yes_answer": "有"
          },
          "school_type": {
            "default": "選択してください",
            "national": "国立",
            "private": "私立",
            "public": "公立",
            "title": "在籍学校の種類",
            "validation_title": "在籍学校の種類"
          },
          "title": "在籍学校について"
        },
        "life_habit": {
          "developmentaldisorder": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "今までに発達障がいと診断されたことはありますか",
            "validation_title": "発達障がいの診断歴の有無",
            "yes_answer": "有"
          },
          "diagnosis": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "診断名",
            "validation_title": "診断名",
            "yes_answer": "有"
          },
          "language": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "お子さまの使用言語",
            "validation_title": "お子さまの使用言語",
            "yes_answer": "有"
          },
          "medical_history": {
            "default": "選択してください",
            "description": "※例：熱性痙攣・肘内障・てんかん・喘息・川崎病・入院手術歴の有無など",
            "no_answer": "無",
            "title": "これまでに経験した病気や手術、怪我、治療歴がありますか",
            "validation_title": "既往歴の有無",
            "yes_answer": "有"
          },
          "medical_history_details": {
            "default": "選択してください",
            "description": "※症状・回数・起こした年齢、現在服薬がある場合はご記入ください（例:熱性痙攣 〇回/時期 〇歳〇か月頃）",
            "no_answer": "無",
            "title": "既往歴の詳細",
            "validation_title": "既往歴の詳細",
            "yes_answer": "有"
          },
          "opportunitynurseryschool": {
            "default": "選択してください",
            "no_answer": "無",
            "title": "今まで、週３日以上の通園経験はありますか",
            "validation_title": "過去3日以上の通園経験の有無",
            "yes_answer": "有"
          },
          "title": "生活習慣・健康状態"
        },
        "planned_participation": {
          "default": "選択してください",
          "elementary_school": "小学生留学",
          "nursery_school": "保育園留学",
          "title": "留学の種類",
          "validation_title": "留学の種類"
        }
      },
      "heading": "予約内容の入力",
      "modal": {
        "breakdown": {
          "adult_rate": "大人料金（税込）※中学生以上",
          "basic_price": "基本料金",
          "child_rate": "子ども料金（1泊）",
          "elementary_aboard": "小学生留学：",
          "not_and_elementary": "留学なし（小学生）：",
          "not_and_toddler": "留学なし（未就学児）：",
          "nursery_aboard": "保育園留学：",
          "option_price": "オプション料金（税込）",
          "plan_price": "プラン料金（税込）",
          "price_number": "￥%{unit_price} × %{number}",
          "promotion": "プロモーション割引",
          "title": "料金の内訳",
          "total": "料金合計（税込）"
        },
        "close": "閉じる",
        "plan_detail": {
          "accommodation": {
            "title": "宿泊施設",
            "type": "宿タイプ：%{type}"
          },
          "adult": "大人%{count}人、",
          "people": "人数：",
          "period": "留学期間：%{start_date}〜%{end_date}",
          "preschool": {
            "eligibility": "受入条件：%{eligibility}",
            "title": "留学施設"
          },
          "preschoolers": "保育園留学%{count}人",
          "preschoolers_1": "留学なし（未就学児）%{count}人",
          "students": "小学生留学%{count}人",
          "students_1": "留学なし（小学生）%{count}人",
          "title": "プラン内容"
        }
      },
      "option_select": {
        "close": "閉じる",
        "label": "オプション説明",
        "notes": "オプションの詳細についてはオプション説明を確認してください。",
        "title": "オプション選択（任意）"
      },
      "price": {
        "breakdown": "内訳",
        "button": "確認へすすむ",
        "total": "料金合計"
      },
      "representative": {
        "account": {
          "account_notes_1": "予約リクエストが完了すると本人確認メールが届きます。",
          "account_notes_2": "確認完了後、マイページへのログイン用アカウントが作成されます。",
          "login": "ログインする",
          "login_link": "＞アカウントをお持ちの方はこちら",
          "login_title": "ログイン",
          "password": "パスワード",
          "password_confirmation": "パスワード（確認用）",
          "password_description": "パスワードは8文字以上64文字以下で、小文字、数字をそれぞれ1文字以上含む必要があります。",
          "reset_password": "パスワードを忘れた方はこちら",
          "title": "アカウント情報"
        },
        "address": {
          "building": "建物名など（任意）",
          "city_town_village": "市町村",
          "country": "国名",
          "email": "メールアドレス",
          "email_notes_1": "本人確認メールが",
          "email_notes_2": "から届きます。携帯メールアドレスの場合は受信許可設定をお願いします。",
          "from_email": "no-reply@kitchhike.com",
          "phone_notes_1": "ハイフン（-）を入れず、数字のみで入力してください。",
          "phone_notes_2": "(例：123-456-7890 → 1234567890)",
          "phone_number": "電話番号",
          "postal_code": "郵便番号",
          "postal_code_notes_1": "ハイフン（-）を入れず、数字のみで入力してください。　(例：123-4567 → 1234567)",
          "prefecture": "都道府県",
          "prefecture_default": "都道府県を選択",
          "street_address": "町域・番地",
          "title": "住所"
        },
        "date_of_birth": "生年月日",
        "first_name": "名（ふりがな）",
        "first_name_cn": "名（漢字）",
        "gender": {
          "female": "女性",
          "male": "男性",
          "other": "その他",
          "title": "性別"
        },
        "last_name": "姓（ふりがな）",
        "last_name_cn": "姓（漢字）",
        "relationship": {
          "brother_sister": "兄弟/姉妹",
          "default": "続柄を選択",
          "father": "父親",
          "grand_father": "祖父",
          "grand_mother": "祖母",
          "mother": "母親",
          "other": "その他",
          "other_text": "その他（任意）",
          "title": "留学する子どもとの続柄"
        },
        "sub_title": "基本情報",
        "title": "代表者情報"
      }
    },
    "reservation_lp": {
      "application_controller": {
        "invalid_preview_url": "プレビューURLが正しくありません。URLに間違いがないかをお確かめください。"
      },
      "price": {
        "adults_number": "大人%{count}名",
        "children_number": "子ども%{count}名"
      }
    },
    "reservation_mailer": {
      "reservation_email": {
        "from": "保育園留学 運営事務局 <no-reply@kitchhike.com>",
        "subject": "予約リクエストありがとうございます【保育園留学 運営事務局】"
      }
    },
    "reset_password_mailer": {
      "from": "保育園留学 運営事務局 <no-reply@kitchhike.com>",
      "subject": "パスワードの変更を受け付けました【保育園留学 運営事務局】"
    },
    "review": {
      "posted_date": "投稿日：%{date}",
      "usage_count": "%{count}回目の留学"
    },
    "review_index": {
      "back_path": "もどる",
      "children_age_text": "年齢",
      "empty": "ご家族の声は見つかりません。",
      "guest_house": "宿泊",
      "message_locals": "%{municipality}の皆さんへのメッセージ",
      "message_preschool": "保育士先生へのメッセージ",
      "number_of_people": {
        "adult": "おとな%{count}人",
        "child": "こども%{count}人",
        "title": "人数",
        "total": "%{count}人"
      },
      "nursery": "場所",
      "read_more": "続きを読む",
      "stay_days": {
        "content": "%{count}週間（%{date}から）",
        "title": "期間"
      }
    },
    "time": {
      "formats": {
        "default": "%Y/%m/%d %H:%M",
        "month": "%-m月",
        "only_time": "%-H:%M",
        "year": "%Y年",
        "year_and_month": "%Y年%-m月",
        "year_and_month_and_day": "%Y年%-m月%-d日"
      }
    },
    "todo_reminder": {
      "posting_review_request": {
        "friends_program": {
          "link": "https://hoikuen-ryugaku.com/friends",
          "text1": "1. お友だち紹介プログラム",
          "text2": "・お友だちをご紹介いただくと、お友だちは10,000円引きで留学ができます。",
          "text3": "・紹介者であるあなたのお子さまが留学した園に、紹介人数分の支援が届きます。",
          "text4": "お友だち紹介プログラムの詳細はこちら："
        },
        "promotion": {
          "text1": "2. 次回、留学時にご利用いただけるプロモーションコード",
          "text2": "保育園留学を2回目以降ご利用いただく場合に割引価格をご案内いたします。",
          "text3": "・予約時にプロモーションコード「again2025」を入れていただくと10,000円割引でご利用が可能です。",
          "text4": "・ご利用条件",
          "text5": "　- 2026年3月31日までに終了する留学にご利用いただけます",
          "text6": "　- プロモーションコードは、1家族1回のみ、前回ご予約をいただいた同じメールアドレスでのご利用となります。",
          "text7": "　- 条件外となるご予約については、対象外となりますのでご了承ください。"
        },
        "subject": "留学後アンケートのお願い【保育園留学 運営事務局】",
        "text1": "こんにちは。保育園留学運営事務局です。\n\nこの度は、保育園留学へのご参加、誠にありがとうございました。",
        "text2": "園の先生方や地域の皆さまへのメッセージと合わせて、ご感想をお寄せいただけますと幸いです。皆さまからいただくお声をもとに、保育園留学が地域とご家族の新たなつながりを築くきっかけとなるよう、一層取り組んでまいります。",
        "text3": "以下のリンクからレビューをご記入ください。",
        "text4": "留学ご家族と地域のご縁を繋ぐプログラムをご紹介させていただきます。",
        "text5": "ぜひご活用いただければ幸いです。",
        "text6": "これからも、子育て世代がより人生を謳歌でき、素晴らしい地域が、これからも持続していく未来を目指して、今後とも尽力してまいります。",
        "text7": "改めて、この度のご参加に心からの感謝を申し上げます。",
        "text8": "どうぞこれからも、よろしくお願いいたします。"
      },
      "three_days_before_reminder": {
        "link": "やることリストを確認する",
        "subject": "期日が近づいているやることリストがあります【保育園留学 運営事務局】",
        "text1": "こんにちは。保育園留学運営事務局です。\nご滞在の準備は順調でしょうか？\nマイページのやることリストに、期日が近づいている項目があります。",
        "text2": "◾️期日が近づいている項目",
        "text3": "お忘れのないようご対応をお願いいたします。",
        "text4": "ご不明な点やサポートが必要な場合は、保育園留学運営事務局へお問い合わせください。",
        "text5": "よろしくお願いいたします。",
        "time_limit": "期日：%{time_limit}"
      },
      "time_limit_reminder": {
        "subject": "やることリストの期日が過ぎています【保育園留学 運営事務局】",
        "text1": "こんにちは。保育園留学運営事務局です。\n先日ご案内したやることリストの項目の期日が過ぎておりますが、まだ完了していないようです。",
        "text2": "◾️未完了の項目",
        "text3": "お手続きが完了していないと、次のステップに進むことができず、ご滞在の準備にも影響が出る可能性がありますので、\nお早めにマイページにてご確認の上、ご対応をお願いいたします。"
      }
    },
    "top": {
      "category_list": {
        "all": "すべて",
        "animal_contact": "動物",
        "baby_friendly": "赤ちゃんといっしょ",
        "car_free_accessible": "車なしで行ける",
        "developmental_support": "発達支援",
        "elementary_ok": "小学生留学",
        "english_available": "English available",
        "english_education": "英語教育",
        "farm_experience": "Farm体験",
        "food_education": "食育",
        "forest_play": "森あそび",
        "historic_streets": "歴史的な街並み",
        "home_town": "ふるさと納税",
        "mud": "泥んこ",
        "pets_allowed": "ペット可",
        "preschool_photo_sharing": "園から写真共有",
        "sea_play": "海あそび",
        "snow_play": "雪あそび",
        "stay_with_meals": "食事付の宿",
        "walk_to_preschool": "徒歩登園",
        "walkable_access": "留学レンタカー",
        "with_coworking": "コワーキングスペースあり"
      },
      "component": {
        "minimum_price": "￥%{minimum_price}〜",
        "people": "大人2名・子ども1名"
      },
      "empty": {
        "text_1": "お探しの条件に当てはまる留学先は見つかりません。",
        "text_2": "条件を変更してお探しください。"
      },
      "filtering": {
        "area": {
          "title": "留学先のエリア"
        },
        "button": {
          "apply": "適用する",
          "clear": "クリア"
        },
        "class": {
          "age": {
            "age_text": "%{age}歳児",
            "asterisk": "（※）",
            "birth_period": "%{start_date}〜%{end_date}",
            "birth_period_header": "生年月日",
            "caution": "（※）0歳は月齢によって受け入れできる地域が異なります。地域の詳細ページでご確認ください。",
            "class_header": "クラス",
            "label": "クラス年齢表",
            "notes": "以下の表から、お子様のクラスをご確認ください。",
            "period": "・留学時期：%{start}年4月1日〜%{end}年3月31日",
            "year": "【%{year}年度】"
          }
        },
        "content": {
          "count": "しぼりこみ結果：%{count}件",
          "title": "留学先一覧"
        },
        "criteria": "しぼりこみ条件：",
        "title": "しぼりこみ"
      },
      "heading": "予約可能な留学先",
      "modal_search": {
        "class": {
          "0_year_old_class": "0歳児クラス",
          "1_year_old_class": "1歳児クラス",
          "2_year_old_class": "2歳児クラス",
          "3_year_old_class": "3歳児クラス",
          "4_year_old_class": "4歳児クラス",
          "5_year_old_class": "5歳児クラス",
          "no_attendance": "登園なし"
        },
        "default_placeholder": "年齢・期間・地域で検索",
        "header": "検索機能",
        "local_transportation": {
          "option_1": "車なしで移動可能",
          "title": "現地での移動手段",
          "value": "車なしで移動可能"
        },
        "month": "月",
        "month_number_from": "ヶ月〜",
        "notice_txt_1": "※留学する時期のクラスをご入力ください。時期が未定の方は現在のクラスをご入力ください。",
        "plan_month": {
          "title": "予定している月を選択してください(最大3つまで)"
        },
        "region": {
          "title": "地域"
        },
        "search_region": {
          "chugoku_shikoku": "中国・四国",
          "hokkaido": "北海道",
          "hokuriku_koshinetsu": "北陸・甲信越",
          "kanto": "関東",
          "kyushu_okinawa": "九州・沖縄",
          "tohoku": "東北",
          "tokai_kinki": "東海・近畿"
        },
        "search_text": {
          "placeholder": "地域・保育園名で検索"
        },
        "stay_day": {
          "subtitle": "滞在期間を選択してください",
          "title": "日程"
        },
        "stay_period": "滞在期間",
        "title": "しぼりこみ",
        "week": "週間",
        "year": " 年"
      },
      "subheading": "予約可能な留学先を表示しています。"
    },
    "url": {
      "cancel_policy": "https://hoikuen-ryugaku.com/stipulation#cancel-policy",
      "conditions": "https://hoikuen-ryugaku.com/jokensho",
      "inquiries": "mailto:support@hoikuen-ryugaku.zendesk.com",
      "privacy_policy": "https://hoikuen-ryugaku.com/privacy-policy",
      "stipulation": "https://hoikuen-ryugaku.com/stipulation",
      "terms_of_use": "https://hoikuen-ryugaku.com/terms-of-use",
      "travel_deal_details": "https://hoikuen-ryugaku.com/travel-deal-details"
    },
    "views": {
      "confirmation": {
        "address": "住所",
        "basic_information": "基本情報",
        "billing_information": "請求情報",
        "birth_date": "生年月日",
        "check_in_time": "宿泊施設への到着予定時刻",
        "children_information": "留学する子どもの情報",
        "confirmation": "入力内容確認",
        "contact_information": "連絡先",
        "emergency_contact_during_stay": "緊急連絡先",
        "exercise_section": "その他(0~1歳の場合のみ)",
        "family_confirmation": "家族情報の入力",
        "family_information": "一緒に滞在する方",
        "full_name": "姓名（漢字）",
        "full_name_reading": "姓名（ふりがな）",
        "gender": "性別",
        "interview_question": "取材・アンケート",
        "living_conditions": "生活習慣・健康状態",
        "meal_and_allergy_information": "食事・アレルギー情報",
        "money_unit": "円",
        "no_input": "未入力",
        "occupation": "職業",
        "option": "オプション",
        "people_unit": "人",
        "primary_contact_information": "代表者情報",
        "reservation_information": "予約情報",
        "school_information": "在籍学校について"
      },
      "edit": "編集する",
      "family_master": {
        "confirmed": "確認しました",
        "headings": {
          "address": "住所",
          "allergy_information": "アレルギー情報",
          "basic_information": "基本情報",
          "contact_information": "連絡先",
          "exercise_section": "その他(0~1歳の場合のみ)",
          "living_conditions": "生活習慣・健康状態について",
          "school_information": "在籍学校について",
          "stay_with": "一緒に滞在する方",
          "work": "仕事"
        },
        "messages": {
          "medical_history_details_note": "※※症状や回数・起こした年齢（例:熱性痙攣 〇回/時期 〇歳〇か月頃）、またご自宅や普段の園生活で配慮している点や留学先の園で対応いただきたいことがある場合もご記入ください。",
          "medical_history_note": "※例：熱性痙攣・肘内障・てんかん・喘息・川崎病・入院手術歴の有無など",
          "special_requests": "※食物アレルギー以外で、宗教上の理由で口にできない食べ物や、ハラール対応が必要な場合など",
          "symptoms_note": "※普段の生活で配慮していることや留学先の園で対応いただきたいことがある場合、またアナフィラキシーがある場合もこちらに必ずご記入ください。"
        },
        "select": "選択してください"
      },
      "flash": {
        "alert": {
          "conditional_requirement_answer": "質問に回答してください",
          "family_confirmation": {
            "no_input": "未入力の項目があります"
          },
          "nursery_meeting": {
            "full": "面談日がいっぱいです。",
            "select": "日付を選択してください。"
          },
          "todo_uploads": "ファイルをアップロードしてください"
        }
      },
      "modal_message": {
        "back": "もどる",
        "complete": "完了にする",
        "final_confirm": "最終確認",
        "final_confirm_message": "この内容で提出してよろしいですか？",
        "final_confirm_message_2": "ご対応は完了しましたか？「完了にする」ボタンを押すと、ステータスが完了になります。",
        "final_confirm_message_3": "この内容で提出してよろしいですか？提出後に修正はできません。",
        "submission": "提出へすすむ",
        "submit": "提出する"
      },
      "mypage": {
        "cancel_fee": "キャンセル料 : ",
        "cancelled": "キャンセル",
        "form": {
          "children_form": "留学する子どもの情報",
          "completions": {
            "done": "提出完了",
            "friends_program": {
              "text": "紹介されたお友だちはお得に留学ができて、あなたが留学した園には、支援が届く。家族と地域の未来につながるプログラムです。",
              "title": "お友だち紹介プログラム",
              "url": "https://hoikuen-ryugaku.com/friends",
              "url_text": "確認する"
            },
            "review_form_done": "回答完了",
            "review_thank_you": "アンケートにご協力をいただき誠にありがとうございました。",
            "thank_you": "ご対応ありがとうございます。お疲れ様でした。",
            "top": "やることリストTOPへ"
          },
          "exist_information": "これまで登録したことがある情報",
          "family_form": "一緒に滞在する方の登録",
          "questionnaire_form": {
            "absent_days": {
              "validation": "（半角数字で入力してください）"
            },
            "completed": "留学後アンケートは回答済みです。",
            "create": {
              "error": "回答内容に不備があります。回答内容をお確かめください。"
            }
          },
          "reservations_form": "予約情報",
          "review_form": {
            "completed": "留学後アンケートは回答済みです。",
            "create": {
              "error": "回答内容に不備があります。回答内容をお確かめください。"
            },
            "head": "いただいた感想と合わせて、保育園留学のホームページでご紹介可能なお写真がありましたらアップロードをお願いいたします",
            "image_count_error": "アップロードできる画像は最大10枚までです。お手数をおかけしますが、画像の枚数をお確かめください。",
            "image_size_error": "1つのファイルの最大サイズは5MBです。お手数をおかけしますが、サイズを超過している画像はリサイズして再度アップロードしてください。",
            "note": "※保育園留学のホームページに、名字をひらがなのみで「⚪︎⚪︎さんご家族」と表示いたします。",
            "upload_image": "画像をアップロードする",
            "validation": "（1枚あたり最大5MB・最大10枚まで）"
          },
          "todo_uploads": {
            "attachment": "添付ファイル",
            "file_size_error": "1つのファイルの最大サイズは20MBです。",
            "upload_file": "ファイルをアップロードする",
            "uploaded_file_1": "添付ファイル1"
          }
        },
        "next_plan": "次の留学先はお決まりですか？",
        "next_plan_message": "すべての地域で、その季節ならではの体験が待っています。次の留学の計画をはじめましょう。",
        "planned_visit": "留学予定",
        "reservation_status": {
          "cancelled": "キャンセル",
          "completed": "留学済み",
          "processing": "リクエスト中",
          "upcoming": "予約確定"
        },
        "search_study_destination": "留学先を探す",
        "visited": "留学済み"
      },
      "questionnaire": {
        "heading": "保育園留学アンケート",
        "note": "本取り組みを、持続的に育てていきたくアンケートのご回答にご協力をお願いいたします。アンケート内容は、株式会社キッチハイクと地域担当者間で共有し、今後のサービスの改善に活用させていただきます。",
        "select": "選択してください"
      },
      "reservation_request": {
        "confirmation_of_reservation": "予約内容の確認 >",
        "confirmed": "確認しました",
        "headings": {
          "emergency_contact_during_stay": "滞在時の緊急ご連絡先",
          "information_during_your_stay": "滞在時の情報",
          "interview_question": "取材アンケート",
          "reservation_information": "予約情報の登録"
        },
        "lets_check": "留学前にチェックしよう",
        "lets_check_bookmark": "「留学のしおり」をみる",
        "lets_check_message": "留学施設の持ち物や宿のチェックイン情報など、留学前に必要な情報をまとめた「留学のしおり」はこちらからご確認いただけます。",
        "messages": {
          "check_in_time_note": "※チェックイン時刻が当日変更となる場合は、必ず宿へ直接ご連絡をお願いします。",
          "emergency_contact_during_stay_note": "留学施設へ滞在中に緊急でご連絡したい場合、こちらへおかけします",
          "emergency_contact_note": "※現地で何かあった際に滞在者ご本人へつながる番号をご入力下さい。宿と園へ共有させていただきます。"
        },
        "plans": {
          "accommodation": "宿泊施設：%{room_name}",
          "adult": "大人%{count}人、",
          "child": "子ども%{count}人",
          "people": "人数：",
          "period": "留学期間：%{start_date}〜%{end_date}",
          "preschool": "保育施設 : %{nursery_name}",
          "preschool_1": "保育施設 : %{nursery_name}",
          "preschool_2": "保育施設2 : %{nursery_name_0}"
        },
        "todo_list": "やることリスト"
      },
      "reservation_request_todo": {
        "arrange_an_interview_date": "期限：面談日程調整をしてください。",
        "asap": "早急に",
        "date": "実施日：%{date}",
        "done": "完了",
        "soon": "近日中に",
        "submission_due_date": "期限：%{date}まで"
      },
      "review": {
        "heading": "保育園留学のご感想・メッセージ"
      },
      "todo": {
        "submission_deadline": "提出期限 : %{date}まで"
      }
    }
  }
}